import AddBoxIcon from '@mui/icons-material/AddBox';
import { Box, Divider, Grid, IconButton, MenuItem, Tooltip, Typography } from '@mui/material';
import _, { debounce } from 'lodash';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';


/** TRANSLATION */
import { useTranslation } from 'react-i18next';

/** API */
import { fileUrl } from 'api/api';
import { ApprovalStatus } from 'api/approval/approval.api';
import TreatmentProductApi from 'api/dentists/treatmentProduct.api';
import ClinicApi from 'api/master/clinic.api';
import ProductInstructionsApi from 'api/setting/default-products/product-instruction.api';
import ProductSymptomApi from 'api/setting/default-products/product-symptom';
import ProductUnitsApi from 'api/setting/default-products/product-unit.api';
import ProductUsesApi from 'api/setting/default-products/product-use.api';
import VoucherApi, { VoucherFindByCodeProps } from 'api/voucher/voucher.api';
import MedicinesApi from 'api/warehouses/medicine.api';

/** CONSTANT */
import * as modalSlice from 'app/slice/modal.slice';
import { fillMissingOrderIndex, loadPromotionTreatments, newStickerProduct, ProductStickerType, promotionsTreatments, setNewStickerProduct, setTreatmentByKey, StickerType, treatment, TreatmentStateInterface } from 'app/slice/treatment.slice';
import { PACKAGE_ADDONS } from 'constants/package';
import { icons, onImgError } from 'constants/images';
import { colors } from 'constants/theme';
import { getBranch, getClinicInfo, getCrm, numberFormat, checkAddons } from 'utils/app.utils';

/** COMPONENT */
import ButtonCustom from 'component/Button/ButtonCustom';
import InputTextField from 'component/Input/InputTextField';
import ModalCustom from 'component/ModalCustom/ModalCustom';
import FunctionPrint from 'component/Print/print';
import AutocompleteSelect from 'component/Select/AutocompleteSelect';
import PdfMedSticker from 'features/pdf/pdf-med-sticker';
import { ImageType } from 'features/treatments/MainMenu/OPD/Med';
import { doctorHasOverDue } from 'features/treatments/SummaryTreatment/SummaryTreatment';
import { DoctorsType } from 'features/treatments/treatmentsIndex';

/** STYLED */
import { showModal } from 'app/slice/modal.slice';
import BasicSelect from 'component/Select/BasicSelect';
import * as UseStyled from 'component/Treatments/style/popupManageProdStyled';
import { notiError, notiSuccess } from 'component/notifications/notifications';
import { IconAddBox } from 'features/treatments/MainMenu/OPD/style/UseStyle';
import { CURRENCY_UNIT, ModalVoucherSelectLot } from './PopupManageTreatmentCourse';

import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InfoIcon from '@mui/icons-material/Info';
import { selectIndex, setSelected } from 'app/slice/select.slice';
import { selectMe } from 'app/slice/user.slice';
import IconCheck from 'assets/icon/iconCheck';
import Loading from 'component/Loading';
import { ModalSelectPromotionExtra, onPromotionSave } from 'features/manage-crm/promotion/promotion-component';
import { ProductBarCode, ProductBox } from 'features/treatments/MainMenu/OPD/style/ProductUseStyle';
import MainButton from 'new-components/buttons/main-button';
import TextInput from 'new-components/inputs/text-input';
import { setTimeout } from 'timers';

import IconClose from '@mui/icons-material/CloseRounded';
import ProductWarningsApi from 'api/setting/default-products/product-warning.api';
import PdfMedStickerView from 'features/pdf/pdf-med-sticker-view';
import { PopupManageProductAddForm } from './PopupManageProductAddForm';

interface PopupManageProductProps {
    page: 'Treatment' | 'Payment' | 'RetrospectiveOrder'
    group: 'MEDICINE' | 'PRODUCT' | 'MATERIAL'
    type: 'thumbnail' | 'summaryTreatment'
    patientName: string
    patientPhone?: string
    item: ProductStickerType | any
    index?: number
    patientCaseId: number
    hasChangeProductPrice?: 'PERMISS' | 'UNPERMISS'
    hasChangeProductDiscountAdditional?: 'PERMISS' | 'UNPERMISS'
    hasChangeTreatmentCost?: 'PERMISS' | 'UNPERMISS'
    onSubmit?: () => void
    onCancel?: () => void
    patientId?: number
    select?: boolean
    userId?: number
    openScanBarcode?: boolean
    qty?: number
}

export const initialProductState: ProductStickerType = {
    sticker: ``,
    tempOrderProductId: 0,
    doctorId: 0,
    qty: 0,
    price: 0,
    discount: 0,
    discountUnit: "BAHT",
    additional: 0,
    additionalUnit: "BAHT",
    total: 0,
    itemId: 0
}

interface ProductObjType {
    id: number
    name: string
    nameEn?: string
}

const initialErrorMessageState = {
    EMPTY_QTY_ORDER: "",
    EMPTY_PRICE: "",
    EMPTY_DOCTOR: "",
    PRICE_RANGE: ""
}

const initProductOutOfStock = {
    name: '',
    code: '',
    qty: 0,
    unit: ''
}

export type PromotionUsageProps = {
    promotionBranchId?: number
    promotionId?: number
    promotionType?: 'DISCOUNT' | 'BUY' | 'EXTRA'
    isMain?: "1" | "0"
    groupNumber?: number

}

export default function PopupManageProduct(props: PopupManageProductProps) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const treatments: TreatmentStateInterface = useSelector(treatment)
    const modal: any = useSelector(modalSlice.handleShow)
    const branch = getClinicInfo();
    const user = useSelector(selectMe)
    const componentRef = useRef<HTMLDivElement>(null)
    const newStickerProducts: ProductStickerType[] = useSelector(newStickerProduct)
    const units: CURRENCY_UNIT[] = [CURRENCY_UNIT.PERCENT, CURRENCY_UNIT.BAHT]
    const promotions = useSelector(promotionsTreatments)
    const [loadPromotionFrist, setLoadPromotionFrist] = useState<boolean>(true)
    const [promotionCurrent, setPromotionCurrent] = useState<any>([])
    const [promotionBranchMain, setPropmotionBranchMain] = useState<any>(null)
    const [promotionLoadClear, setPromotionLoadClear] = useState<boolean>(false)
    const [promotionDelId, setPromotionDelId] = useState<number>(0)
    const [promotionProduct, setPromotionProduct] = useState<PromotionUsageProps[]>([])
    const [promotionProductCurrent, setPromotionProductCurrent] = useState<PromotionUsageProps[]>([])

    const [popPromotionExtra, setPopPromotionExtra] = useState<boolean>(false)
    const [promotionExtraValue, setPromotionExtraValue] = useState<any>({})
    const [promotionExtraBuy, setPromotionExtraBuy] = useState<any>([])
    const [promotionExtraNew, setPromotionExtraNew] = useState<any>([])

    const [promotionBuy, setPromotionBuy] = useState<any>([])
    const [promotionExtra, setPromotionExtra] = useState<any>([])
    const [disabledSave, setDisabledSave] = useState<boolean>(false)

    const [voucherLoadClear, setVoucherLoadClear] = useState<boolean>(false)
    const [voucherProduct, setVoucherProduct] = useState<any>({})
    const [vouchers, setVoucher] = useState<any>({})
    const [popVoucherSelectLot, setPopVoucherSelectLot] = useState<boolean>(false)
    const [dataPopVoucherSelectLot, setDataPopVoucherSelectLot] = useState<any>({})
    const [searchVoucher, setSearchVoucher] = useState<string>("")
    const [errorSearchVoucher, setErrorSearchVoucher] = useState<string>("")

    const hasPriceRangeAddon = useMemo(() => checkAddons(PACKAGE_ADDONS.ADDON_PRICE_RANGE), [])

    /** MenuItem ของหน่วย (PERCENT/BAHT) — คงที่ ขึ้นกับ t เท่านั้น ไม่ต้องสร้าง JSX ใหม่ทุก render */
    const unitMenuItems = useMemo(
        () => units.map((unit: string, index: number) => (
            <MenuItem key={index} value={unit}>
                {unit === CURRENCY_UNIT.PERCENT ? '%' : t('CURRENCY_CHANGE.TH')}
            </MenuItem>
        )),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [t]
    )

    // data
    const [product, setProduct] = useState<ProductStickerType>(props.item);
    const [stickerProduct, setStickerProduct] = useState<any>({});
    const [errorMessage, setErrorMessage] = useState(initialErrorMessageState);
    const [isShowAddProductChoice, setIsShowAddProductChoice] = useState<boolean>(false)
    const [typeAdd, setTypeAdd] = useState<'PRODUCT_SYMPTOM' | 'PRODUCT_USES' | 'PRODUCT_UNITS' | 'PRODUCT_INSTRUCTION'>('PRODUCT_INSTRUCTION')
    const [items, setItems] = useState<any>()
    const [medicineInformationId, setMedicineInformationId] = useState<any>()

    // default data
    const [doctors, setDoctors] = useState<DoctorsType[]>([]);
    const [doctor, setDoctor] = useState<any>({});
    const [productInstructions, setProductInstructions] = useState<ProductObjType[]>([]);
    const [productUnits, setProductUnits] = useState<ProductObjType[]>([]);
    const [productUses, setProductUses] = useState<ProductObjType[]>([]);
    const [productSymptom, setProductSymptom] = useState<ProductObjType[]>([]);
    const [productWarning, setProductWarning] = useState<ProductObjType[]>([]);

    // loading
    const [loading, setLoading] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);
    const [maxLength, setMaxLength] = useState<number>(0);
    const selectedIndex = useSelector((state: any) => state.select.index);
    const [scanBarcode, setScanBarcode] = useState('')
    const [itemsBarcode, setItemsBarcode] = useState<any>([])
    const [stickerBarcode, setStickerBarcode] = useState<any>([])
    const [isActive, setIsActive] = useState(false);

    // Use refs to store latest values for debounced function
    const itemsBarcodeRef = useRef(itemsBarcode)
    const treatmentsRef = useRef(treatments.summeryTreatments)
    const stickerBarcodeRef = useRef(stickerBarcode)
    const stickerProductRef = useRef(stickerProduct)
    const promotionBranchMainRef = useRef(promotionBranchMain)
    const voucherProductRef = useRef(voucherProduct)
    const productRef = useRef(product)
    const selectedIndexRef = useRef(selectedIndex)

    // sync ค่าล่าสุดเข้า ref (ใช้ใน debounced callback) — รวมเป็น effect เดียว
    useEffect(() => {
        itemsBarcodeRef.current = itemsBarcode
        treatmentsRef.current = treatments.summeryTreatments
        stickerBarcodeRef.current = stickerBarcode
        stickerProductRef.current = stickerProduct
        promotionBranchMainRef.current = promotionBranchMain
        voucherProductRef.current = voucherProduct
        productRef.current = product
        selectedIndexRef.current = selectedIndex
    }, [itemsBarcode, treatments.summeryTreatments, stickerBarcode, stickerProduct, promotionBranchMain, voucherProduct, product, selectedIndex])

    const loadData = async () => {
        const newItem: any = props?.item
        if (newItem.itemId !== 0 && !props.openScanBarcode) {
            try {
                setLoading(true)
                setProduct(props.item)
                setPropmotionBranchMain(props.item?.promotion?.[0])
                setItemsBarcode([props.item])
                setPromotionProduct(newItem?.promotion)
                setVoucherProduct(newItem?.voucher)
                setSearchVoucher(newItem?.voucher?.voucherCode)
                setPromotionProductCurrent(newItem?.promotion)
                if (newItem.sticker && props.group !== 'MEDICINE') {
                    const sticker = {
                        ...JSON.parse(newItem.sticker),
                        isPriceRange: newItem?.isPriceRange,
                        minSalePrice: newItem?.minSalePrice,
                        maxSalePrice: newItem?.maxSalePrice,
                    }
                    setStickerProduct(sticker)
                    handleChangeStickerProductDetail(sticker)
                } else {
                    const stickerPd: StickerType = createBaseSticker(newItem, JSON.parse(newItem.sticker))
                    if (props.group === 'MEDICINE' && newItem.sticker || newItem?.itemInfo) {
                        await handleSticker(newItem.itemId, JSON.parse(newItem.sticker || newItem?.itemInfo))
                    } else if (props.group === 'MEDICINE' && !newItem.sticker) {
                        const sticker = await handleSticker(newItem.itemId, stickerPd)
                        handleChangeStickerProductDetail(sticker)
                    } else {
                        setStickerProduct(stickerPd)
                        handleChangeStickerProductDetail(stickerPd)
                    }
                }
            } catch (error) {
                console.error('Error fetching product:', error);
            } finally {
                setLoading(false);
            }
        } else {
            const condition: any = { page: 1, pageLimit: 100, branchId: getBranch(), userId: props.userId, group: props.group };
            if (scanBarcode.length === 13) {
                try {
                    const resp = await TreatmentProductApi.findAllProduct({ ...condition, search: scanBarcode });
                    if (resp.data.length === 1) {
                        const resInfo = (props.group === 'MEDICINE' && resp.data[0]?.itemId) ? await TreatmentProductApi.getMedicineInformation(resp.data[0]?.itemId) : null
                        const newSticker = (resInfo?.data && resInfo?.data?.sticker) ? JSON.parse(resInfo?.data?.sticker) : {}
                        const newData = (resInfo?.data && resInfo?.data?.productId)
                            ?
                            { ...resp.data[0], oldSticker: newSticker, medicineInformationId: resInfo?.data?.medicineInformationId || 0 }
                            :
                            resp.data[0]
                        await handleBarcodeScan(newData);
                    } else {
                        notiError(t('ไม่พบสินค้านี้'))
                        setScanBarcode("")
                    }
                } catch (error) {
                    console.error('Error fetching product:', error);
                } finally {
                    setLoading(false);
                }
            } return
        }
        setLoading(false)
    }

    const handleSticker = async (id: number, sticker: any) => {
        if (id) {
            if (props.page === "RetrospectiveOrder") {
                const res = props.group === 'MEDICINE' ? await TreatmentProductApi.getMedicineInformation(id) : ''
                if (res.status === 200 && res.data && !sticker) {
                    const rawData = res.data.sticker
                    const data = JSON.parse(rawData)
                    const objSticker: StickerType = {
                        ...sticker,
                        // dosage: data.dosage,
                        ...handleProductDetail(sticker, data),
                        logo: branch?.branchLogo,
                        clinicName: branch?.clinicAndBranchName,
                        branchAddress: branch?.branchFullAddress,
                        branchTel: branch?.branchPhone,
                        patientFullName: props?.patientName
                    }
                    let newData: any = {}
                    if ((!objSticker?.image || !objSticker?.stock)) {
                        const item: any = props.item
                        newData = {
                            ...stickerProduct, ...objSticker,
                            image: item?.image || {},
                            stock: item?.stock || "0"
                        }
                    } else {
                        newData = { ...stickerProduct, ...objSticker }
                    }
                    setStickerProduct({ ...newData, medicineInformationId: res.data.medicineInformationId })
                    handleChangeStickerProductDetail({ ...newData, medicineInformationId: res.data.medicineInformationId })
                    setMedicineInformationId(res.data.medicineInformationId)
                    return newData
                } else if (props.group === 'MEDICINE' && props.type === 'thumbnail' && id) {
                    await MedicinesApi.findById(id)
                        .then(({ data }: any) => {
                            const objSticker: StickerType = {
                                ...sticker,
                                productInstructionId: data?.productInstruction?.productInstructionId,
                                productInstructionName: data?.productInstruction?.productInstructionName,
                                productUnitId: data?.productUnit?.productUnitId,
                                productUnitName: data?.productUnit?.productUnitName,
                                productUnitNameEn: data?.productUnit?.productUnitNameEn,
                                productUseId: data?.productUse?.productUseId,
                                productUseDetail: data?.productUse?.productUseDetail,
                                logo: branch?.branchLogo,
                                clinicName: branch?.clinicAndBranchName,
                                branchAddress: branch?.branchFullAddress,
                                branchTel: branch?.branchPhone,
                                patientFullName: props?.patientName
                            }
                            setStickerProduct({ ...stickerProduct, ...objSticker })
                            handleChangeStickerProductDetail({ ...stickerProduct, ...objSticker })
                            return { ...stickerProduct, ...objSticker }
                        })
                        .catch(() => { return })
                        .finally(() => setLoading(false))
                } else {
                    setStickerProduct(sticker)
                    handleChangeStickerProductDetail(sticker)
                    setLoading(false)
                    return sticker
                }
            } else {
                await TreatmentProductApi.findStickerById(props.patientCaseId, id).then(async (resp) => {
                    if (!resp.data || resp.data?.length === 0) {
                        const res = props.group === 'MEDICINE' ? await TreatmentProductApi.getMedicineInformation(id) : ''
                        if (res.status === 200 && res.data && res.data?.length !== 0 && !sticker) {
                            const rawData = res.data.sticker
                            const data = JSON.parse(rawData)
                            const objSticker: StickerType = {
                                ...sticker,
                                // dosage: data.dosage,
                                ...handleProductDetail(sticker, data),
                                logo: branch?.branchLogo,
                                clinicName: branch?.clinicAndBranchName,
                                branchAddress: branch?.branchFullAddress,
                                branchTel: branch?.branchPhone,
                                patientFullName: props?.patientName
                            }
                            let newData: any = {}

                            if ((!objSticker?.image || !objSticker?.stock)) {
                                const item: any = props.item
                                newData = {
                                    ...stickerProduct, ...objSticker,
                                    image: item?.image || {},
                                    stock: item?.stock || "0"
                                }
                            } else {
                                newData = { ...stickerProduct, ...objSticker }
                            }
                            setStickerProduct({ ...newData, medicineInformationId: res.data.medicineInformationId })
                            handleChangeStickerProductDetail({ ...newData, medicineInformationId: res.data.medicineInformationId })
                            setMedicineInformationId(res.data.medicineInformationId)
                            return newData
                        } else if (props.group === 'MEDICINE' && props.type === 'thumbnail' && id) {
                            await MedicinesApi.findById(id)
                                .then(({ data }: any) => {
                                    const objSticker: StickerType = {
                                        ...sticker,
                                        productInstructionId: data?.productInstruction?.productInstructionId,
                                        productInstructionName: data?.productInstruction?.productInstructionName,
                                        productUnitId: data?.productUnit?.productUnitId,
                                        productUnitName: data?.productUnit?.productUnitName,
                                        productUnitNameEn: data?.productUnit?.productUnitNameEn,
                                        productUseId: data?.productUse?.productUseId,
                                        productUseDetail: data?.productUse?.productUseDetail,
                                        productWarningId: data?.productWarning?.productWarningId,
                                        productWarningDetail: data?.productWarning?.productWarningDetail || productWarning.find((e: any) => data?.productWarningId === e.id)?.name,
                                        logo: branch?.branchLogo,
                                        clinicName: branch?.clinicAndBranchName,
                                        branchAddress: branch?.branchFullAddress,
                                        branchTel: branch?.branchPhone,
                                        patientFullName: props?.patientName
                                    }
                                    setStickerProduct({ ...stickerProduct, ...objSticker })
                                    handleChangeStickerProductDetail({ ...stickerProduct, ...objSticker })
                                    return { ...stickerProduct, ...objSticker }
                                })
                                .catch(() => { return })
                                .finally(() => setLoading(false))
                        } else {
                            setStickerProduct(sticker)
                            handleChangeStickerProductDetail(sticker)
                            setLoading(false)
                            return sticker
                        }
                    } else {
                        if (resp.status === 200 && resp.data) {
                            const rawData = resp.data?.[0].sticker
                            const data = JSON.parse(rawData)
                            const objSticker: StickerType = {
                                ...sticker,
                                dosage: data.dosage,
                                ...handleProductDetail(null, data),
                                logo: branch?.branchLogo,
                                clinicName: branch?.clinicAndBranchName,
                                branchAddress: branch?.branchFullAddress,
                                branchTel: branch?.branchPhone,
                                patientFullName: props?.patientName
                            }
                            let newData: any = {}
                            if ((!objSticker?.image || !objSticker?.stock)) {
                                const item: any = props.item
                                newData = {
                                    ...stickerProduct, ...objSticker,
                                    image: item?.image || {},
                                    stock: item?.stock || "0"
                                }
                            } else {
                                newData = { ...stickerProduct, ...objSticker }
                            }
                            setStickerProduct({ ...newData, medicineInformationId: resp.data?.[0]?.medicineInformationId })
                            handleChangeStickerProductDetail({ ...newData, medicineInformationId: resp.data?.[0]?.medicineInformationId })
                            setMedicineInformationId(resp.data?.[0]?.medicineInformationId)
                            return newData
                        } else if (props.group === 'MEDICINE' && props.type === 'thumbnail' && id) {
                            await MedicinesApi.findById(id)
                                .then(({ data }: any) => {
                                    const objSticker: StickerType = {
                                        ...sticker,
                                        productInstructionId: data?.productInstruction?.productInstructionId,
                                        productInstructionName: data?.productInstruction?.productInstructionName,
                                        productUnitId: data?.productUnit?.productUnitId,
                                        productUnitName: data?.productUnit?.productUnitName,
                                        productUnitNameEn: data?.productUnit?.productUnitNameEn,
                                        productUseId: data?.productUse?.productUseId,
                                        productUseDetail: data?.productUse?.productUseDetail,
                                        productWarningId: data?.productWarning?.productWarningId,
                                        productWarningDetail: data?.productWarning?.productWarningDetail || productWarning.find((e: any) => data?.productWarningId === e.id)?.name,
                                        logo: branch?.branchLogo,
                                        clinicName: branch?.clinicAndBranchName,
                                        branchAddress: branch?.branchFullAddress,
                                        branchTel: branch?.branchPhone,
                                        patientFullName: props?.patientName
                                    }
                                    setStickerProduct({ ...stickerProduct, ...objSticker })
                                    handleChangeStickerProductDetail({ ...stickerProduct, ...objSticker })
                                    return { ...stickerProduct, ...objSticker }
                                })
                                .catch(() => { return })
                                .finally(() => setLoading(false))
                        } else {
                            setStickerProduct(sticker)
                            handleChangeStickerProductDetail(sticker)
                            setLoading(false)
                            return sticker
                        }
                    }
                })
            }

        }
        setLoading(false)
    }

    const handleProductDetail = (sticker: any, data: any) => {
        const productWarningDetail = productWarning.find((e: any) => data?.productWarningId === e.id)
        const newData = {
            productInstructionId: sticker?.productInstructionId || data.productInstructionId,
            productInstructionName: sticker?.productInstructionName || data.productInstructionName,
            productUnitId: sticker?.productUnitId || data.productUnitId,
            productUnitName: sticker?.productUnitName || data.productUnitName,
            productUseId: sticker?.productUseId || data.productUseId,
            productUseDetail: sticker?.productUseDetail || data.productUseDetail,
            productSymptomId: sticker?.productSymptomId || data.productSymptomId,
            productSymptomDetail: sticker?.productSymptomDetail || data.productSymptomDetail,
            productWarningId: sticker?.productWarningId || data?.productWarningId,
            productWarningDetail: sticker?.productWarningDetail || data?.productWarningDetail || data?.productWarningName || productWarningDetail?.name,
        }
        return newData
    }

    const loadDefaultProductInstructions = (search?: string) => {
        ProductInstructionsApi
            .findAll({ status: 'ACTIVE', group: 'MEDICINE', pageLimit: 10, search: search || '' })
            .then(({ data }) => {
                let newProductInstructions: ProductObjType[] = []
                _.forEach(data, (i) => {
                    newProductInstructions = [...newProductInstructions, { id: i.productInstructionId, name: i.productInstructionName || i.productInstructionNameEn }]
                })
                setProductInstructions(newProductInstructions)
            })
            .catch(() => { return })
            .finally(() => {
                setDataLoading(false)
            })
    }

    const loadDefaultProductUnits = (search?: string) => {
        ProductUnitsApi
            .findAll({ status: 'ACTIVE', group: 'MEDICINE', pageLimit: 10, search: search || '' })
            .then(({ data }) => {
                let newProductUnits: ProductObjType[] = []
                _.forEach(data, (i) => {
                    newProductUnits = [...newProductUnits, { id: i.productUnitId, name: i.productUnitName, nameEn: i.productUnitNameEn }]
                })
                setProductUnits(newProductUnits)
            })
            .catch(() => { return })
            .finally(() => {
                setDataLoading(false)
            })
    }

    const loadDefaultProductUses = (search?: string) => {
        ProductUsesApi
            .findAll({ status: 'ACTIVE', group: 'MEDICINE', pageLimit: 10, search: search || '' })
            .then(({ data }) => {
                let newProductUses: ProductObjType[] = []
                _.forEach(data, (i) => {
                    newProductUses = [...newProductUses, { id: i.productUseId, name: i.productUseDetail }]
                })
                setProductUses(newProductUses)
            })
            .catch(() => { return })
            .finally(() => {
                setDataLoading(false)
            })
    }
    const loadDefaultProductSymtom = (search?: string) => {
        ProductSymptomApi
            .findAll({ status: 'ACTIVE', group: 'MEDICINE', pageLimit: 10, search: search || '' })
            .then(({ data }) => {
                let newProductSymptom: ProductObjType[] = []
                _.forEach(data, (i) => {
                    newProductSymptom = [...newProductSymptom, { id: i.productSymptomId, name: i.detail }]
                })
                setProductSymptom(newProductSymptom)
            })
            .catch(() => { return })
            .finally(() => {
                setDataLoading(false)
            })
    }

    const loadDefaultProductWarning = (search?: string) => {
        ProductWarningsApi
            .getProductWarning({ status: 'ACTIVE', group: 'MEDICINE', pageLimit: 99, search: search || '', page: 1, sortType: '', sortBy: '' })
            .then(({ data }) => {
                let newProductWarning: ProductObjType[] = []
                _.forEach(data, (i) => {
                    newProductWarning = [...newProductWarning, { id: i.productWarningId, name: i.productWarningName }]
                })
                setProductWarning(newProductWarning)
            })
            .catch(() => { return })
            .finally(() => {
                setDataLoading(false)
            })
    }

    const loadDefaultDoctor = () => {
        ClinicApi.findAllDoctors()
            .then(({ data }) => {
                setDoctors(data)
                setDoctor(_.find(data, { userId: props.item.doctorId }))
            })
            .catch(() => { return })
    }

    const renderImage = (image: ImageType) => {
        if (image?.filePath && image?.fileName) return `${fileUrl}/${image.filePath}/${image.fileName}`
        else if (props.group === 'MATERIAL') return icons.matDefault
        else if (props.group === 'PRODUCT') return icons.prodDefault
        else return icons.medDefault
    }

    const handleChangeProductDetail = async (name: string, val: number | string, course?: boolean) => {
        let value = val
        const elementNameNumber = ['doctorId', "discountUnit", "additionalUnit"]
        if (!elementNameNumber.includes(name)) {
            const valueNumber = !value ? 0 : String(value).replace(/[^0-9.]/g, '')
            value = Number(valueNumber)
            setVoucherProduct({})
            setSearchVoucher("")
        }
        if (!course && name !== 'qty') {
            // ตรวจสอบ price range เมื่อมีการเปลี่ยน price
            if (name === 'price' && (product as any)?.isPriceRange === '1' && (product as any)?.maxSalePrice) {
                const min = Number((product as any).minSalePrice) || 0
                const max = Number((product as any).maxSalePrice) || 0
                const priceValue = Number(value) || 0

                if (hasPriceRangeAddon && ((priceValue < min) || (max && priceValue > max))) {
                    setErrorMessage({
                        ...initialErrorMessageState,
                        PRICE_RANGE: `${t('PRODUCT.FORM.PRICE_RANGE') || 'ราคาช่วง'}: ${numberFormat(min)} - ${numberFormat(max)} ${t('CURRENCY_CHANGE.TH')}`
                    })
                } else {
                    setErrorMessage(initialErrorMessageState)
                }
            } else if (name === 'price') {
                // Clear error เมื่อไม่มี price range หรือเปลี่ยน field อื่น
                setErrorMessage(initialErrorMessageState)
            }
            setProduct({ ...product, [name]: value })
        } else {
            let newValue = String(val);
            const cleanedValue = newValue.replace(/[^0-9.]/g, '');
            if (cleanedValue === '') {
                return;
            }
            newValue = cleanedValue;
            if (newValue.indexOf('.') !== newValue.lastIndexOf('.')) {
                newValue = newValue.slice(0, newValue.lastIndexOf('.'));
            }
            const inputValue = Number(newValue)
            // Update product immediately for UI responsiveness
            setProduct({ ...product, [name]: inputValue })

            // Update itemsBarcode immediately for UI responsiveness
            const updatedItemsBarcode = [...itemsBarcode];
            updatedItemsBarcode[selectedIndex] = { ...updatedItemsBarcode[selectedIndex], [name]: inputValue }
            setItemsBarcode(updatedItemsBarcode)

            // Use debounced function for qty changes to call APIs
            if (name === 'qty') {
                const promotionDel = updatedItemsBarcode[selectedIndex]?.promotion?.length ? updatedItemsBarcode[selectedIndex].promotion.map((item: any) => item?.promotionBranchId) : []
                const newItemBarcode = updatedItemsBarcode?.map((item: any) => {
                    if (item?.promotion?.length) {
                        return { ...item, promotion: [...item?.promotion?.filter((info: any) => !promotionDel.includes(info?.promotionBranchId))] }
                    } else {
                        return item
                    }
                })

                debouncedHandleQtyPromotionApiCalls({
                    newItemBarcode,
                    inputValue: inputValue,
                    course: course || false
                })
            }
            return // Return early for course case
        }

        if (!elementNameNumber.includes(name)) {
            setVoucherProduct({})
            setSearchVoucher("")
            const updatedItemsBarcode = [...itemsBarcode];
            updatedItemsBarcode[selectedIndex] = { ...updatedItemsBarcode[selectedIndex], [name]: value }
            const promotionDel = updatedItemsBarcode[selectedIndex]?.promotion?.length ? updatedItemsBarcode[selectedIndex].promotion.map((item: any) => item?.promotionBranchId) : []
            const newItemBarcode = updatedItemsBarcode?.map((item: any) => {
                if (item?.promotion?.length) {
                    return { ...item, promotion: [...item?.promotion?.filter((info: any) => !promotionDel.includes(info?.promotionBranchId))] }
                } else {
                    return item
                }
            })

            // Use debounced function for qty changes, otherwise call directly
            if (name === 'qty') {
                debouncedHandleQtyPromotionApiCalls({
                    newItemBarcode,
                    inputValue: Number(value),
                    course: course || false
                })
            } else {
                onLoadPromotionTreatments(newItemBarcode)
            }

            setItemsBarcode(newItemBarcode)

            if (name === 'qty') {
                setPromotionCurrent([]);
                setPropmotionBranchMain({});
                setPromotionProduct([]);
                setPromotionProductCurrent([]);
                setPromotionExtraValue({});
                setPromotionExtraBuy([]);
                setPromotionExtraNew([]);
                setPromotionBuy([]);
                setPromotionExtra([]);
            }

        } else {
            const updatedItemsBarcode = [...itemsBarcode];
            updatedItemsBarcode[selectedIndex] = {
                ...updatedItemsBarcode[selectedIndex],
                [name]: value
            }
            setItemsBarcode(updatedItemsBarcode);
        }

        // reset errors on change; range will be validated on submit (ยกเว้น price ที่ตรวจสอบแล้ว)
        if (name !== 'price') {
            setErrorMessage(initialErrorMessageState);
        }
    };

    const handleChangeStickerProductDetail = (sticker: any) => {
        const index = _.findIndex(stickerBarcode, { itemId: sticker.itemId });
        const hasSticker = _.some(stickerBarcode, { itemId: sticker.itemId });
        if (!hasSticker) {
            setStickerBarcode([...stickerBarcode, sticker]);
        } else {
            if (index !== -1 && stickerBarcode.length > 0) {
                const newStickerBarcode = [...stickerBarcode];
                newStickerBarcode[index] = { ...newStickerBarcode[index], ...sticker };
                setStickerBarcode(newStickerBarcode);
                // stickerBarcode[index] = { ...stickerBarcode[index], ...sticker }
            }
        }
    };


    const onRemember = async () => {
        const newValue: any = {
            sticker: JSON.stringify(stickerProduct),
            qty: product.qty,
            itemId: product.itemId
        }

        const newId = stickerBarcode.find((item: any) => item?.itemId === newValue?.itemId)
        if (newId?.medicineInformationId) {
            const res = await TreatmentProductApi.editMedicineInformation(newId?.medicineInformationId, newValue)
            if (res.status === 200) {
                notiSuccess(t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.REMEM_SUCCESS'))
            }
        }
        else {
            const res = await TreatmentProductApi.addMedicineInformation(newValue)
            if (res.status === 201) {
                notiSuccess(t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.SAVE_SUCCESS'))
            }
        }
    }

    const handlePromotionDiscount = (pd: any) => {
        const dataPromotion = pd?.promotionBranchMain

        console.log('dataPromotion',dataPromotion)
        if (dataPromotion?.type === "DISCOUNT") {
            if (dataPromotion?.promotionPriceType === "DISCOUNT") {
                const newData = {
                    promotionDiscount: dataPromotion?.promotionPrice,
                    promotionDiscountUnit: dataPromotion?.promotionPriceUnit === CURRENCY_UNIT.PERCENT ? dataPromotion?.promotionPriceUnit : CURRENCY_UNIT.BAHT
                }
                return newData
            } else {

                console.log("cal_sum(true, pd) - dataPromotion?.promotionPrice",pd, cal_sum(true, pd),cal_sum(true, pd) - dataPromotion?.promotionPrice)
                const newData = {
                    promotionDiscount: cal_sum(true, pd) - dataPromotion?.promotionPrice,
                    promotionDiscountUnit: dataPromotion?.promotionPriceUnit === CURRENCY_UNIT.PERCENT ? dataPromotion?.promotionPriceUnit : CURRENCY_UNIT.BAHT
                }
                return newData
            }
        } else {
            return {
                promotionDiscount: 0,
                promotionDiscountUnit: CURRENCY_UNIT.BAHT
            }
        }
    }

    const handleVoucherDiscount = (pd: any) => {
        const dataVoucher = pd?.voucher
        const check = dataVoucher?.voucherId
        const newVoucherDiscount = dataVoucher?.voucherPriceType === "DISCOUNT" ? Number(dataVoucher?.voucherPrice || 0) : cal_sum(true, pd) - Number(dataVoucher?.voucherPrice || 0)
        return {
            voucher: dataVoucher || {},
            voucherListId: check ? (Number(dataVoucher?.voucherListId || 0)) : 0,
            voucherDiscount: check ? newVoucherDiscount : 0,
            voucherDiscountUnit: check ? (dataVoucher?.voucherPriceUnit === "BATH" || dataVoucher?.voucherPriceUnit === "BAHT") ? CURRENCY_UNIT.BAHT : CURRENCY_UNIT.PERCENT : CURRENCY_UNIT.BAHT,
        }
    }

    const onCheckPromotionCurrent = (data: any) => {
        const promotionCurrentId = promotionProductCurrent?.find((item: any) => item?.isMain === '1')?.promotionBranchId
        const currentList = !_.isEmpty(promotionProduct) && !promotionLoadClear && voucherLoadClear ? promotionProduct : promotionLoadClear ? promotionProduct : product?.promotion;
        const promotionId = currentList?.find((item: any) => item?.isMain === '1')?.promotionBranchId

        if (promotionCurrentId && promotionCurrentId !== promotionId) {
            const newData: any[] = []
            data.forEach((item: any) => {
                if (item?.promotion?.length && item?.promotion?.some((info: any) => info?.promotionBranchId === promotionCurrentId)) {
                    if (item?.promotion?.some((info: any) => info?.promotionType !== "EXTRA")) {
                        return newData.push({ ...item, promotion: item?.promotion?.filter((i: any) => i?.promotionBranchId !== promotionCurrentId) })
                    }
                } else {
                    return newData.push(item)
                }
            })
            return newData
        } else {
            return data
        }
    }

    const handleDataSubmit = async () => {
        let newTreatmentSum: any[] = handleSetTreatmentAll();
        let hasError = false;
        const newItem: any = props?.item

        for (const i in itemsBarcode) {
            const barcodeItem = itemsBarcode[i];

            let stickerStock = Number(stickerBarcode[i].stock || 0)

            if (barcodeItem.itemId === newItem.itemId && newItem.group === barcodeItem.group) {
                    stickerStock = Number(newItem.stock || stickerBarcode[i].stock || 0)
                }


            if (barcodeItem.qty > (stickerStock || 0) || barcodeItem.discount > (barcodeItem.price * barcodeItem.qty)) {
                deleteItem(Number(i));
                continue;
            } else if (barcodeItem.price.toString() === '' || !barcodeItem.qty) {
                setErrorMessage({
                    EMPTY_QTY_ORDER: !barcodeItem.qty ? t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.EMPTY_QTY_ORDER') : '',
                    EMPTY_PRICE: barcodeItem.price.toString() === '' ? t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.EMPTY_PRICE') : '',
                    EMPTY_DOCTOR: '',
                    PRICE_RANGE: ""
                });
                continue;
            } else if (
                (barcodeItem as any)?.isPriceRange === '1' &&
                (barcodeItem as any)?.maxSalePrice > 0
            ) {
                const min = Number((barcodeItem as any).minSalePrice) || 0
                const max = Number((barcodeItem as any).maxSalePrice) || 0
                const price = Number(barcodeItem.price) || 0
                if (hasPriceRangeAddon && ((price < min) || (max && price > max))) {
                    setErrorMessage({
                        ...initialErrorMessageState,
                        PRICE_RANGE: `${t('PRODUCT.FORM.PRICE_RANGE') || 'ราคาช่วง'}: ${numberFormat(min)} - ${numberFormat(max)} ${t('CURRENCY_CHANGE.TH')}`
                    })
                    hasError = true;
                    break;
                }
            } else {
                const isReload = props.openScanBarcode || promotionLoadClear || voucherLoadClear;
                const total = cal_sum(false, barcodeItem);

                let newTemId = 0
                if (!barcodeItem?.tempOrderProductId && props.page !== "RetrospectiveOrder") {
                    await TreatmentProductApi.findStickerById(props.patientCaseId, barcodeItem.itemId, { isCreate: '1' }).then(({ data }) => {
                        newTemId = Math.max(...data.map((item: any) => item.tempOrderProductId))
                    });
                }
                const newProduct = {
                    ...barcodeItem,
                    tempOrderProductId: newTemId || barcodeItem?.tempOrderProductId,
                    stock: stickerBarcode[i].stock,
                    total: total,
                    sticker: JSON.stringify(stickerBarcode[i]),
                    fullPrice: cal_sum(true, barcodeItem),
                    isReload: isReload,
                    promotion: barcodeItem?.promotion,
                    ...handlePromotionDiscount(barcodeItem),
                    ...handleVoucherDiscount(barcodeItem)
                };
                if (props.page !== "RetrospectiveOrder") {
                    onSaveSticker(total, newProduct, stickerBarcode[i]);
                }

                const { dataTreatmentsPromotions: summaryTreatment, errorExtra, newBuy, newExtra, errorBuy } = await onPromotionSave({
                    patient: { patientCaseId: props?.patientCaseId, patientName: props?.patientName, patientId: props?.patientId },
                    promotionExtraBuy: newProduct?.promotionExtraBuy || [],
                    promotionExtraNew: newProduct?.promotionExtraNew || [],
                    promotionExtraValue: newProduct?.promotionExtraValue || [],
                    dataPromotions: (promotionLoadClear || (newProduct?.promotion && newProduct.promotion.length > 0)) && newProduct,
                    treatments: { ...treatments, summeryTreatments: newTreatmentSum },
                    user,
                    t: t,
                    doctorId: props.userId,
                });
                if (errorExtra || errorBuy) {
                    setDisabledSave(false);
                    return;
                }

                const summaryTreatments = props.page !== "RetrospectiveOrder" ? summaryTreatment : _.merge([], newTreatmentSum);
                const hasItemInSummary = _.findIndex(summaryTreatments, (sum: any) => {
                    if (!sum?.promotion?.length) return sum?.itemId === newProduct?.itemId;
                    else return sum?.itemId === newProduct?.itemId && sum?.promotion.every((info: any) => info?.promotionType !== 'EXTRA');
                });

                if (hasItemInSummary < 0) {
                    newTreatmentSum = [...summaryTreatments, newProduct, ...newBuy, ...newExtra];
                } else {
                    if (hasItemInSummary || hasItemInSummary === 0) {
                        const newSummaryTreatments = [...summaryTreatments];
                        newSummaryTreatments[hasItemInSummary] = newProduct
                        const newTreatment = onCheckPromotionCurrent(newSummaryTreatments);
                        newTreatmentSum = [...newTreatment, ...newBuy, ...newExtra];
                    }
                }
            }
        }

        if (hasError) {
            return null;
        }

        return newTreatmentSum;
    };


    const onSubmitPopup = async () => {
        if (disabledSave) return
        setDisabledSave(true)
        if (_.isEmpty(itemsBarcode)) setItemsBarcode(product)
        if (_.isEmpty(stickerBarcode)) setStickerBarcode(stickerProduct)
        const newTreatmentSum: any = await handleDataSubmit()

        if (!newTreatmentSum || !newTreatmentSum.length) {
            // validation failed; keep modal open and stop all processing
            setDisabledSave(false)
            return
        }
        // const mergedResult = mergeSummeryTreatments(treatments.summeryTreatments, itemsBarcode);
        // const newTreatments = _.filter(treatments.summeryTreatments, (item) => item.tempOrderProductId !== newTreatmentSum?.[0].tempOrderProductId)
        dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: fillMissingOrderIndex([...newTreatmentSum]) }))
        setDisabledSave(false)
        //    await onRemember()
        props.onSubmit && props.onSubmit()
    }

    const onSaveSticker = async (total: number, pd?: any, sk?: any) => {
        const pdItem = !pd ? product : pd
        const skItem = !sk ? stickerProduct : sk
        const newValue: ProductStickerType = {
            sticker: JSON.stringify(skItem),
            tempOrderProductId: pdItem.tempOrderProductId,
            doctorId: pdItem.doctorId,
            qty: pdItem.qty,
            price: pdItem.price,
            discount: pdItem.discount,
            discountUnit: pdItem.discountUnit,
            additional: pdItem.additional,
            additionalUnit: pdItem.additionalUnit,
            total: total,
            itemId: pdItem.itemId
        }
        if (!newValue.tempOrderProductId) {
            const i = _.filter(newStickerProducts, (stk: ProductStickerType) => stk.itemId !== pd.itemId)
            dispatch(setNewStickerProduct({ value: [...i, newValue] }))
        } else {
            await TreatmentProductApi.updateStickerById(props.patientCaseId, newValue.itemId, newValue).then(() => { return }).catch(() => { return })
        }
    }

    const handleInputSearch = useCallback(
        _.debounce((type: 'productInstructions' | 'productUnits' | 'productUses' | 'productSymptom' | 'productWarning', search?: string) => {
            if (type === 'productInstructions') loadDefaultProductInstructions(search)
            if (type === 'productUnits') loadDefaultProductUnits(search)
            if (type === 'productUses') loadDefaultProductUses(search)
            if (type === 'productSymptom') loadDefaultProductSymtom(search)
            if (type === 'productWarning') loadDefaultProductWarning(search)
        }, 1000), []);

    useEffect(() => {
        loadData()
    }, [scanBarcode, props.item])

    useEffect(() => {
        if (props.group === 'MEDICINE' && (props.type === 'thumbnail' || props.type === 'summaryTreatment')) {
            loadDefaultProductInstructions()
            loadDefaultProductUnits()
            loadDefaultProductUses()
            loadDefaultProductSymtom()
            loadDefaultProductWarning()
            loadDefaultDoctor()
        }
        else {
            loadDefaultDoctor()
        }
    }, [props.group, props.type, props.item,]);

    useEffect(() => {
        if (productWarning.length > 0 && stickerProduct.productWarningId) {
            const warning = productWarning.find((e: any) => e.id === stickerProduct.productWarningId)
            if (warning && stickerProduct.productWarningDetail !== warning.name) {
                const newSticker = { ...stickerProduct, productWarningDetail: warning.name }
                setStickerProduct(newSticker)
                handleChangeStickerProductDetail(newSticker)
            }
        }
    }, [productWarning, stickerProduct.productWarningId, stickerProduct.productWarningDetail])

    const reloadProduct = () => {
        loadDefaultProductInstructions()
        loadDefaultProductUnits()
        loadDefaultProductUses()
        loadDefaultProductSymtom()
        loadDefaultProductWarning()
    }

    const onAddProduct = (type: any, items: any, maxLength: number) => {
        setTypeAdd(type);
        setItems(items);
        setMaxLength(maxLength);
        setIsShowAddProductChoice(true);
        dispatch(showModal());
    };

    const onAddProductInstruction = () => onAddProduct('PRODUCT_INSTRUCTION', productInstructions, 80);
    const onAddProductUnit = () => onAddProduct('PRODUCT_UNITS', productUnits, 10);
    const onAddProductUse = () => onAddProduct('PRODUCT_USES', productUses, 40);
    const onAddProductSymptom = () => onAddProduct('PRODUCT_SYMPTOM', productSymptom, 40);
    const onAddProductWarning = () => onAddProduct('PRODUCT_WARNING', productWarning, 40);

    const handleBarcodeScan = async (data: any) => {
        if (!data?.itemId) { return; }
        if (data?.qty < 1) {
            switch (props.group) {
                case 'MEDICINE':
                    notiError(t("TREATMENT_PRODUCT.MEDICINE.MED_OUT"));
                    break;
                case 'MATERIAL':
                    notiError(t("TREATMENT_PRODUCT.MATERIAL.PD_OUT"));
                    break;
                default:
                    notiError(t("TREATMENT_PRODUCT.PRODUCT.PD_OUT"));
            }
            return;
        }
        const hasItem = treatments.summeryTreatments.find((item: any) => item.itemId === data.itemId && (!item?.promotion?.length || item?.promotion?.every((info: any) => info?.promotionType !== 'EXTRA')));
        const hasItemsBarcode = itemsBarcode.some((item: any) => item.itemId === data.itemId);

        if (hasItem?.tempOrderProductId) {
            const sticker = JSON.parse(hasItem?.sticker || "{}") || {}
            const currentQty = (hasItem?.qty || 0) + 1;
            const baseProduct = {
                ...hasItem,
                qty: currentQty,
                total: cal_sum(false, { ...hasItem, qty: currentQty }),
                image: sticker?.image || {}
            }

            setProduct(baseProduct);

            const delPromotionId = baseProduct?.promotion?.length ? baseProduct?.promotion?.map((item: any) => item?.promotionBranchId) : 0
            setPromotionCurrent([]);
            setPropmotionBranchMain({});
            setPromotionDelId(delPromotionId);
            setPromotionProduct([]);
            setPromotionProductCurrent([]);
            setPromotionExtraValue({});
            setPromotionExtraBuy([]);
            setPromotionExtraNew([]);
            setPromotionBuy([]);
            setPromotionExtra([]);
            setVoucherProduct({})
            setSearchVoucher("")

            const updatedItemsBarcode = [...itemsBarcode, baseProduct];
            const newItemBarcode = updatedItemsBarcode?.map((item: any) => {
                if (item?.promotion?.length) {
                    return { ...item, promotion: [...item?.promotion?.filter((info: any) => !delPromotionId.includes(info?.promotionBranchId))] }
                } else {
                    return item
                }
            })
            setItemsBarcode(newItemBarcode);
            if (updatedItemsBarcode.length >= 1) {
                setIsActive(!isActive);
                dispatch(selectIndex(updatedItemsBarcode.length - 1));
                dispatch(setSelected({ key: updatedItemsBarcode.length - 1, value: updatedItemsBarcode[updatedItemsBarcode.length - 1] }));
            }
            setScanBarcode('');
            if (baseProduct.sticker) {
                const sticker = JSON.parse(baseProduct.sticker)
                setStickerProduct(sticker)
                handleChangeStickerProductDetail(sticker)
            } else {
                const stickerPd: StickerType = createBaseSticker(data, data.sticker)
                if (props.group === 'MEDICINE') {
                    const sticker = await handleSticker(data.itemId, stickerPd)
                    handleChangeStickerProductDetail(sticker)
                } else {
                    setStickerProduct(stickerPd)
                    handleChangeStickerProductDetail(stickerPd)
                }
            }
        } else if (!hasItemsBarcode && !data.sticker) {

            const stickerPd: StickerType = await createBaseSticker(data, data?.oldSticker)
            const baseProduct = await createBaseProduct(data, stickerPd, 1);

            setStickerProduct(stickerPd)
            handleChangeStickerProductDetail(stickerPd)

            const index = _.findIndex(stickerBarcode, { itemId: data.itemId });
            setProduct(baseProduct);
            setScanBarcode('');
            const updatedItemsBarcode = [...itemsBarcode, baseProduct];
            setPromotionCurrent([]);
            setPropmotionBranchMain({});
            setPromotionDelId(0);
            setPromotionProduct([]);
            setPromotionProductCurrent([]);
            setPromotionExtraValue({});
            setPromotionExtraBuy([]);
            setPromotionExtraNew([]);
            setPromotionBuy([]);
            setPromotionExtra([]);
            setVoucherProduct({})
            setSearchVoucher("")

            onLoadPromotionTreatments(updatedItemsBarcode)
            setItemsBarcode(updatedItemsBarcode);

            if (index !== -1) {
                stickerBarcode[index] = { ...stickerBarcode[index], ...stickerPd }
            }
            if (updatedItemsBarcode.length >= 1) {
                setIsActive(!isActive);
                dispatch(selectIndex(updatedItemsBarcode.length - 1));
                dispatch(setSelected({ key: updatedItemsBarcode.length - 1, value: updatedItemsBarcode[updatedItemsBarcode.length - 1] }));
            }
        } else {
            const index = _.findIndex(itemsBarcode, { itemId: data.itemId });
            const currentQty = Number(itemsBarcode[index].qty || 0) + 1;
            const updatedItem = {
                ...itemsBarcode[index],
                qty: currentQty,
                total: itemsBarcode[index].price * currentQty,
                discount: Number(itemsBarcode[index]?.discount) || 0,
                discountUnit: itemsBarcode[index]?.discountUnit || 'BAHT',
                additional: Number(itemsBarcode[index]?.additional) || 0,
                additionalUnit: itemsBarcode[index]?.additionalUnit || 'BAHT'
            };

            const stickerPd: StickerType = await createBaseSticker(data, data.sticker)
            setStickerProduct(stickerPd)
            setProduct(updatedItem)

            const newItemsBarcode = itemsBarcode.map((info: any, num: number) => {
                if (num === index) {
                    return updatedItem
                } else {
                    return info
                }
            })

            onLoadPromotionTreatments(newItemsBarcode)
            setItemsBarcode(newItemsBarcode);
            setPromotionCurrent([]);
            setPropmotionBranchMain({});
            setPromotionDelId(0);
            setPromotionProduct([]);
            setPromotionProductCurrent([]);
            setPromotionExtraValue({});
            setPromotionExtraBuy([]);
            setPromotionExtraNew([]);
            setPromotionBuy([]);
            setPromotionExtra([]);
            setVoucherProduct({})
            setSearchVoucher("")
            setIsActive(!isActive);
            dispatch(selectIndex(index));
            dispatch(setSelected({ key: index, value: updatedItem }));
            setScanBarcode('');
        }
    };


    const createBaseSticker = (data: any, sticker: any) => ({
        ...sticker,
        itemId: data.itemId,
        itemName: data.itemName,
        itemNameEn: data.itemNameEn,
        itemCode: data.itemCode,
        image: {
            fileId: data?.image?.fileId || null,
            filePath: data?.image?.filePath || '',
            fileName: data?.image?.fileName || ''
        },
        stock: data.qty,
        defaultProductUnitName: data.itemUnitName || data.itemUnitNameEn,
        dosage: 1,
        expiredDate: data.expireDate || '',
        itemRecommend: '',
        medicineInformationId: data?.medicineInformationId || 0,
        isPriceRange: data?.isPriceRange,
        minSalePrice: data?.minSalePrice,
        maxSalePrice: data?.maxSalePrice
    });


    const createBaseProduct = (data: any, sticker: StickerType, qty: number) => ({
        ...data,
        sticker: JSON.stringify(sticker),
        doctorId: data.doctorId,
        qty,
        price: data.price,
        discount: 0,
        discountUnit: 'BAHT',
        additional: 0,
        additionalUnit: 'BAHT',
        total: data.price * qty
    });



    const seleteItemBarCode = (med: any, index: number) => {
        setLoading(true)
        setTimeout(() => {
            setProduct(med)
            setPromotionDelId(med?.promotionDelId || [])
            setPromotionExtraBuy(med?.promotionExtraBuy || [])
            setPromotionExtraValue(med?.promotionExtraValue || [])
            setPromotionExtraNew(med?.promotionExtraNew || [])
            setPromotionProduct(med?.promotion)
            setVoucherProduct(med?.voucher)
            setSearchVoucher(med?.voucher?.voucherCode)
            const newOption = promotions.find((item: any) => item?.itemId === med?.itemId)?.vouchers || []
            setVoucher(newOption)
            setStickerProduct(stickerBarcode[index])
        }, 500);
        setIsActive(!isActive)
        dispatch(selectIndex(index));
        dispatch(setSelected({ key: index, value: med }));
        setLoading(false)
    }



    const handleSubmit = (data: any, type: any) => {
        const autoSelect: any = {
            PRODUCT_INSTRUCTION: { productInstructionId: data.productInstructionId, productInstructionName: data.productInstructionName, productInstructionNameEn: data.productInstructionNameEn },
            PRODUCT_UNITS: { productUnitId: data.productUnitId, productUnitName: data.productUnitName, productUnitNameEn: data.productUnitNameEn },
            PRODUCT_USES: { productUseId: data.productUseId, productUseDetail: data.productUseDetail, productUseDetailEn: data.productUseDetailEn },
            PRODUCT_SYMPTOM: { productSymptomId: data.productSymptomId, productSymptomDetail: data.detail, productSymptomDetailEn: data.detailEn },
            PRODUCT_WARNING: { productWarningId: data.productWarningId, productWarningDetail: data.productWarningName }
        }

        reloadProduct()
        const newStickerProduct = { ...stickerProduct, ...autoSelect[type] }
        // setStickerProduct({ ...stickerProduct, ...autoSelect[type] })
        setStickerProduct(newStickerProduct)
        handleChangeStickerProductDetail(newStickerProduct)
        return setIsShowAddProductChoice(false)
    }

    const handleDiscard = async (labelId: any, id: any) => {
        if (labelId === 'productInstructionId') {
            await ProductInstructionsApi
                .remove(id)
                .then(({ data }) => {
                    reloadProduct()
                    const newStickerProduct = {
                        ...stickerProduct,
                        productInstructionId: 0,
                        productInstructionName: ''
                    }
                    setStickerProduct(newStickerProduct)
                })
                .catch((e) => {
                    const err = e.response.data
                    return notiError(t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.${err.message}`))
                })
        }
        if (labelId === 'productUnitId') {
            await ProductUnitsApi
                .remove(id)
                .then(() => {
                    reloadProduct()
                    const newStickerProduct = {
                        ...stickerProduct,
                        productUnitId: 0,
                        productUnitName: '',
                        productUnitNameEn: '',
                    }
                    setStickerProduct(newStickerProduct)
                })
                .catch((e) => {
                    const err = e.response.data
                    return notiError(t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.${err.message}`))
                })
        }
        if (labelId === 'productUseId') {
            await ProductUsesApi
                .remove(id)
                .then(() => {
                    reloadProduct()
                    const newStickerProduct = {
                        ...stickerProduct,
                        productUseId: 0,
                        productUseDetail: ''
                    }
                    setStickerProduct(newStickerProduct)
                })
                .catch((e) => {
                    const err = e.response.data
                    return notiError(t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.${err.message}`))
                })
        }
        if (labelId === 'productSymptomId') {
            await ProductSymptomApi
                .remove(id)
                .then(() => {
                    reloadProduct()
                    const newStickerProduct = {
                        ...stickerProduct,
                        productSymptomId: 0,
                        productSymptomDetail: ''
                    }
                    setStickerProduct(newStickerProduct)
                })
                .catch((e) => {
                    const err = e.response.data
                    return notiError(t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.${err.message}`))
                })
        }
        if (labelId === 'productWarningId') {
            ProductWarningsApi.deleteProductWarning(id)
                .then(() => {
                    reloadProduct()
                    const newStickerProduct = {
                        ...stickerProduct,
                        productWarningId: 0,
                        productWarningDetail: ''
                    }
                    setStickerProduct(newStickerProduct)
                })
                .catch((e) => {
                    const err = e.response.data
                    return notiError(t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.${err.message}`))
                })
        }

    }

    const cal_sum = (fullPrice?: boolean, pd?: any) => {
        const pdItem = !pd ? product : pd


        const dataPromotion = pd?.promotionBranchMain || promotionBranchMain
        const dataVoucher = pd?.voucher || voucherProduct

         const discount = pdItem.discountUnit === "BAHT" ? pdItem.discount : (pdItem.price * pdItem.qty) * (pdItem.discount / 100)
            const additional = pdItem.additionalUnit === "BAHT" ? pdItem.additional : (pdItem.price * pdItem.qty) * (pdItem.additional / 100)
            const newTotal = ((pdItem.price * pdItem.qty) - discount) + additional


        console.log('pdItem',pdItem)
        console.log('pd',pd)
        console.log('product',product,dataPromotion)

        const renderCalPromtoion = (total: number) => {
            const baht = ["BAHT", ""]
            if (dataPromotion?.type === "DISCOUNT") {
                if (dataPromotion?.promotionPriceType === "DISCOUNT") {
                    if (baht.includes(dataPromotion?.promotionPriceUnit)) {
                        return total - dataPromotion.promotionPrice <= 0 ? 0 : total - dataPromotion?.promotionPrice
                    } else {
                        const perDiscount = (total * dataPromotion?.promotionPrice || 0) / 100
                        return total - perDiscount <= 0 ? 0 : total - perDiscount
                    }
                } else {
                    return dataPromotion.promotionPrice
                }
            } else {
                return total
            }
        }
        const rendercalVoucher = (total: number) => {
            if (dataVoucher?.voucherId) {
                if (dataVoucher?.voucherPriceUnit === 'PERCENT') {
                    return total * ((dataVoucher?.voucherPrice || 0) / 100)
                } else {
                    return dataVoucher?.voucherPrice || 0
                }
            } else {
                return 0
            }
        }

        if(fullPrice) return newTotal
        
        if (props.group !== 'MEDICINE') { 
            if ((dataPromotion?.promotionBranchId || dataVoucher?.voucherId) ) {
                return (renderCalPromtoion(newTotal) || 0) - (rendercalVoucher(newTotal) || 0)
            } else {
                return newTotal || 0
            }
        } else {
            if ((dataPromotion?.promotionBranchId || dataVoucher?.voucherId) ) {
                return (renderCalPromtoion(newTotal) || 0) - (rendercalVoucher(newTotal) || 0)
            } else {
                return newTotal || 0
            }
        }
    }

    const onClerPopPromotionExtra = () => {
        setPromotionExtra([])
        setPopPromotionExtra(false)
    }

    const onChangePromotionExtra = (data: any, dataBuy?: any) => {
        if (promotionExtraValue?.promotionBranchId && (dataBuy[0]?.groupNumber || promotionExtraBuy[0]?.groupNumber)) {
            batch(() => {
                setPromotionLoadClear(true)
                onClerPopPromotionExtra()
                if (dataBuy?.length) setPromotionExtraBuy(dataBuy)
                setPromotionExtraNew(data)
                const newproductPromotion = promotionProduct?.length ? promotionProduct?.filter((item) => item?.isMain !== "1") : []
                setPromotionProduct([
                    ...newproductPromotion,
                    {
                        promotionBranchId: promotionExtraValue?.promotionBranchId,
                        promotionType: "BUY",
                        promotionId: promotionExtraValue?.promotionId,
                        isMain: '1',
                        groupNumber: (dataBuy[0]?.groupNumber || promotionExtraBuy[0]?.groupNumber)
                    }
                ])
            })
        }
    }

    const handleSetTreatmentAll = (data?: any) => {
        const newItem = data || itemsBarcode
        const oldData = treatments?.summeryTreatments?.filter((sum: any) => {
            if (!newItem.some((item: any) => item?.itemId === sum.itemId) || (sum?.promotion?.length && sum.promotion.every((info: any) => info?.promotionType === "EXTRA"))) {
                return sum
            }
        })
        const newProduct = newItem?.map((item: any) => {
            const newSticker = stickerBarcode?.find((info: any) => info?.itemId === item?.itemId)
            return {
                ...item,
                stock: newSticker?.stock || 0,
                total: cal_sum(false, item),
                sticker: newSticker ? JSON.stringify(newSticker) : "",
                fullPrice: cal_sum(true, item)
            }
        })
        const summaryTreatments = [...oldData, ...newProduct]
        return summaryTreatments
    }

    /** เคลียร์ state promotion ทั้งหมด (ใช้ตอนกดกากบาท / toggle ตัวเดิมออก) — batch กัน re-render หลายรอบ */
    const clearPromotionAll = () => {
        batch(() => {
            setPromotionLoadClear(true)
            setPropmotionBranchMain(null)
            setPromotionProduct([])
            setPromotionExtraNew([])
            setPromotionExtraBuy([])
            setPromotionBuy([])
            setPromotionExtra([])
            setPromotionExtraValue({})
            setPromotionCurrent([])
        })
    }

    const handleChangePromotionProduct = (value: any) => {
      batch(() => {
        const pCId = promotionProductCurrent?.find((item: any) => item?.isMain === '1')?.promotionBranchId || 0
        setPromotionDelId(pCId)
        setPromotionLoadClear(true)
        if (value?.promotionBranchId) {
            if (value?.type === "EXTRA" && value?.extra?.length) {
                const newBuy: any[] = []
                const newExtra: any[] = []
                value?.extra.forEach((item: any) => {
                    if (item?.type === "BUY") {
                        const buyInfo = newBuy[item?.groupNumber - 1] || []
                        newBuy[item?.groupNumber - 1] = [...buyInfo, item]
                    } else {
                        const extraInfo = newExtra[item?.groupNumber - 1] || []
                        newExtra[item?.groupNumber - 1] = [...extraInfo, item]
                    }
                })

                const onChangeTreatmentSum = (num: number) => {
                    const newData = [...handleSetTreatmentAll()]
                    newData[num] = product
                    return newData
                }

                const treatmentSum = handleSetTreatmentAll()?.findIndex((item: any) => item?.itemId === product?.itemId && (!item?.promotion?.length || item?.promotion?.length && item?.promotion?.every((info: any) => info?.promotionType !== "EXTRA")))
                const treatmentSummerys = treatmentSum < 0 ? [...handleSetTreatmentAll(), product] : onChangeTreatmentSum(treatmentSum)

                let autoPromotionBuy = null

                if (newBuy?.length) {
                    const treatmentSummerysCanUse = treatmentSummerys.filter((item: any) => {
                        if (!item?.promotion?.length || (item?.promotion?.length && item?.promotion.some((info: any) => info?.promotionType !== "EXTRA"))) return item
                    }).map((item: any) => { return { itemId: item?.operativeId || item?.itemId, qty: item.qty } })
                    const dataBuyCanUse = newBuy.find((info: any) => info.every((i: any) => {
                        return treatmentSummerysCanUse.some((t: any) => t?.itemId === i?.itemId && t?.qty === i?.qty)
                    }))
                    if (dataBuyCanUse) {
                        autoPromotionBuy = dataBuyCanUse
                        setPromotionExtraBuy(dataBuyCanUse)
                    }
                    else setPromotionBuy(newBuy?.filter((item: any) => item.some((info: any) => info?.itemId === product?.itemId))
                        .map((item: any) => item.map((info: any) => { return { ...info, disabled: !treatmentSummerysCanUse.some((t: any) => t?.itemId === info?.itemId && t?.qty === info?.qty) } })) || [])
                }

                if (autoPromotionBuy && autoPromotionBuy[0]?.groupNumber && newExtra?.length === 1) {
                    setPromotionExtraValue(value)
                    setPromotionExtraNew(newExtra[0])
                    const newproductPromotion = promotionProduct?.length ? promotionProduct?.filter((item) => item?.isMain !== "1") : []
                    setPromotionProduct([
                        ...newproductPromotion,
                        {
                            promotionBranchId: value?.promotionBranchId,
                            promotionType: "BUY",
                            promotionId: value?.promotionId,
                            isMain: '1',
                            groupNumber: autoPromotionBuy[0]?.groupNumber
                        }
                    ])
                } else {
                    setPromotionExtraValue(value)
                    setPromotionExtra(newExtra)
                    setPopPromotionExtra(true)
                }
            } else {
                setPromotionExtraNew([])
                setPromotionExtraBuy([])
                setPromotionBuy([])
                setPromotionExtraValue({})
                const newproductPromotion = promotionProduct?.length ? promotionProduct?.filter((item) => item?.isMain !== "1") : []
                setPromotionProduct([
                    ...newproductPromotion,
                    {
                        promotionBranchId: value?.promotionBranchId,
                        promotionType: value?.type,
                        promotionId: value?.promotionId,
                        isMain: '1'
                    }
                ])
            }
        } else {
            setPromotionExtraNew([])
            setPromotionExtraBuy([])
            setPromotionBuy([])
            setPromotionExtraValue({})
            const newproductPromotion = promotionProduct?.length ? promotionProduct?.filter((item) => item?.isMain !== "1") : []
            setPromotionProduct(newproductPromotion)
        }
      })
    }

    // Function to handle API calls when qty changes
    const handleQtyPromotionApiCalls = useCallback(async (data: { newItemBarcode: any, inputValue: number, course: boolean }) => {
        // Use current state from refs to ensure we're working with latest data
        const currentItemsBarcode = itemsBarcodeRef.current
        const currentTreatments = treatmentsRef.current
        const currentStickerBarcode = stickerBarcodeRef.current
        const currentStickerProduct = stickerProductRef.current
        const currentProduct = productRef.current
        const currentSelectedIndex = selectedIndexRef.current

        // Handle TreatmentApi.getTxc for course case
        // if (data.course && props?.patientId) {
        //     try {
        //         const resp = await TreatmentApi.getTxc(Number(props.patientId))
        //         if (resp.status === 200) {
        //             const arrayPatientTreatmentCourse = _.find(
        //                 resp.data,
        //                 (item) => item?.patientTreatmentCourseId === currentProduct?.patientTreatmentCourseId
        //             )
        //             const treatmentCourse = _.find(
        //                 arrayPatientTreatmentCourse?.patientTreatmentCourseItems,
        //                 (item) => item?.itemId === currentProduct?.inventoryId)

        //             const totalQty = currentTreatments
        //                 .filter((item: any, index: number) => item.inventoryId === currentProduct?.inventoryId && index !== props.index && item.patientTreatmentCourseId === currentProduct?.patientTreatmentCourseId)
        //                 .reduce((sum: number, item: any) => sum + Number(item.qty || 0), 0)
        //             const remainingQty = Math.max(treatmentCourse?.balance - totalQty, 0);
        //             const finalQty = data.inputValue > remainingQty ? remainingQty : data.inputValue;

        //             // Update product with final qty
        //             setProduct({ ...currentProduct, qty: finalQty })

        //             // Update itemsBarcode with final qty using latest data from refs
        //             const latestItemsBarcode = itemsBarcodeRef.current
        //             const updatedItemsBarcode = [...latestItemsBarcode];
        //             const latestSelectedIndex = selectedIndexRef.current
        //             if (updatedItemsBarcode[latestSelectedIndex]) {
        //                 updatedItemsBarcode[latestSelectedIndex] = { ...updatedItemsBarcode[latestSelectedIndex], qty: finalQty }
        //                 setItemsBarcode(updatedItemsBarcode)
        //                 // Update ref for next use
        //                 itemsBarcodeRef.current = updatedItemsBarcode
        //             }
        //         }
        //     } catch (error) {
        //         console.error('Error fetching treatment course:', error)
        //     }
        // }

        // Handle loadPromotionTreatments
        if (props?.patientId && props.page !== "RetrospectiveOrder") {
            const hasItemInSummary = _.some(currentTreatments, (sum: any, index) => {
                if (!sum?.promotion?.length) {
                    return data.newItemBarcode.some((item: any) => item?.itemId === sum.itemId)
                } else {
                    return data.newItemBarcode.some((item: any) => item?.itemId === sum.itemId) && sum?.promotion.every((info: any) => info?.promotionType !== 'EXTRA')
                }
            })
            if (!hasItemInSummary) {
                const updatedData = data.newItemBarcode.map((item: any) => {
                    const newSticker = currentStickerBarcode?.find((info: any) => info?.itemId === item?.itemId)
                    return {
                        ...item,
                        stock: newSticker?.stock || 0,
                        total: cal_sum(false, item),
                        sticker: newSticker ? JSON.stringify(currentStickerProduct) : "",
                        fullPrice: cal_sum(true, item)
                    }
                });
                const newData = [...currentTreatments, ...updatedData]
                dispatch(loadPromotionTreatments(props?.patientId, newData))
            } else {
                const oldData = currentTreatments?.filter((sum: any) => {
                    if (!data.newItemBarcode.some((item: any) => item?.itemId === sum.itemId)) {
                        return sum
                    }
                })

                const newProduct = data.newItemBarcode?.map((item: any) => {
                    const newSticker = currentStickerBarcode?.find((info: any) => info?.itemId === item?.itemId)
                    return {
                        ...item,
                        stock: newSticker?.stock || 0,
                        total: cal_sum(false, item),
                        sticker: newSticker ? JSON.stringify(currentStickerProduct) : "",
                        fullPrice: cal_sum(true, item)
                    }
                })
                const summaryTreatments = [...oldData, ...newProduct]
                dispatch(loadPromotionTreatments(props?.patientId, summaryTreatments))
            }
        }
    }, [dispatch, props?.patientId, props.page, props.index])

    // Debounced version of handleQtyPromotionApiCalls (800ms delay - wait for user to finish typing before calling API)
    const debouncedHandleQtyPromotionApiCalls = useMemo(
        () => debounce((data: any) => {
            // This will only be called once after user stops typing for 800ms
            handleQtyPromotionApiCalls(data)
        }, 800),
        [handleQtyPromotionApiCalls]
    )

    // Cleanup debounced function on unmount
    useEffect(() => {
        return () => {
            debouncedHandleQtyPromotionApiCalls.cancel()
        }
    }, [debouncedHandleQtyPromotionApiCalls])

    const onLoadPromotionTreatments = (data: any) => {
        if (props?.patientId && props.page !== "RetrospectiveOrder") {
            const hasItemInSummary = _.some(treatments.summeryTreatments, (sum: any, index) => {
                if (!sum?.promotion?.length) {
                    return data.some((item: any) => item?.itemId === sum.itemId)
                } else {
                    return data.some((item: any) => item?.itemId === sum.itemId) && sum?.promotion.every((info: any) => info?.promotionType !== 'EXTRA')
                }
            })
            if (!hasItemInSummary) {
                const updatedData = data.map((item: any) => {
                    const newSticker = stickerBarcode?.find((info: any) => info?.itemId === item?.itemId)
                    return {
                        ...item,
                        stock: newSticker?.stock || 0,
                        total: cal_sum(false, item),
                        sticker: newSticker ? JSON.stringify(stickerProduct) : "",
                        fullPrice: cal_sum(true, item)
                    }
                });
                const newData = [...treatments.summeryTreatments, ...updatedData]
                dispatch(loadPromotionTreatments(props?.patientId, newData))
            } else {

                const oldData = treatments?.summeryTreatments?.filter((sum: any) => {
                    if (!data.some((item: any) => item?.itemId === sum.itemId)) {
                        return sum
                    }
                })

                const newProduct = data?.map((item: any) => {
                    const newSticker = stickerBarcode?.find((info: any) => info?.itemId === item?.itemId)
                    return {
                        ...item,
                        stock: newSticker?.stock || 0,
                        total: cal_sum(false, item),
                        sticker: newSticker ? JSON.stringify(stickerProduct) : "",
                        fullPrice: cal_sum(true, item)
                    }
                })
                const summaryTreatments = [...oldData, ...newProduct]
                dispatch(loadPromotionTreatments(props?.patientId, summaryTreatments))
            }
        }
    }

    useEffect(() => {
        if (loadPromotionFrist && itemsBarcode?.length) {
            setLoadPromotionFrist(false)
            onLoadPromotionTreatments(itemsBarcode)
        }
    }, [itemsBarcode])

    const handleSetPromotionCurrent = (option?: any) => {
        let mainId = 0
        const newOp = option || promotionProduct || []
        if (newOp?.length) {
            const promotionUsage = newOp?.map((item: any) => {
                if (item?.isMain === '1') {
                    mainId = item?.promotionBranchId || 0
                }
                return item?.promotionBranchId
            })
            const newExtra: any[] = []
            const newPromotions = promotions.find((item: any) => item?.itemId === product?.itemId)?.promotions || []
            const promotionItem = treatments?.summeryTreatments.find((item: any) => item?.promotion?.some((info: any) => info?.promotionType === 'EXTRA' && info?.promotionBranchId === mainId))?.promotion?.find((item: any) => item?.promotionBranchId === mainId)
            // หา main item แยกออกมา (เลิกทำ side effect ใน .filter — filter ต้อง pure)
            const mainItem = (newPromotions?.length && promotionUsage?.length) ? newPromotions.find((item: any) => item?.promotionBranchId === mainId) : null
            if (mainItem) {
                if (mainItem?.type === "EXTRA" && promotionItem?.groupNumber) {
                    mainItem?.extra.forEach((info: any) => {
                        if (info?.type === "EXTRA" && promotionItem?.groupNumber === info?.groupNumber) {
                            newExtra.push(info)
                        }
                    })
                }
            }
            const newPromotionCurrent = (newPromotions?.length && promotionUsage?.length)
                ? newPromotions.filter((item: any) => promotionUsage.includes(item?.promotionBranchId))
                : []
            batch(() => {
                if (mainItem) setPropmotionBranchMain(mainItem)
                if (promotionItem?.groupNumber && !promotionExtraNew?.length) {
                    setPromotionExtraNew(newExtra)
                }
                setPromotionCurrent(newPromotionCurrent)
            })
        } else {
            setPromotionCurrent([])
        }
    }

    useEffect(() => {
        handleSetPromotionCurrent()
    }, [promotionProduct])

    const handleVoucher = () => {
        if (promotions?.length && product?.itemId) {
            const newOption = promotions.find((item: any) => item?.itemId === product?.itemId)?.vouchers || []
            setVoucher(newOption)
        }
    }

    useEffect(() => {
        if (promotions?.length && product?.itemId) {
            const newOption = promotions.find((item: any) => item?.itemId === product?.itemId)?.promotions || []
            // ใช้ functional setState อ่าน promotionProduct ล่าสุด (กัน stale closure ตอน mount/reopen
            // ที่ค่า initial = [] ทับ promo ที่ loadData เพิ่ง set)
            setPromotionProduct((prev: any) => {
                const promotionUsage = prev?.map((item: any) => item?.promotionBranchId) || []
                // ไม่มี promo ใช้อยู่ → อย่าไปแตะ (กันล้างค่า saved ตอน reopen)
                if (!promotionUsage.length) return prev
                const operativeMain = prev?.find((item: any) => item?.isMain === '1')
                const newPromotion: any = []
                newOption.forEach((item: any) => {
                    if (promotionUsage.includes(item?.promotionBranchId)) {
                        const checkMain = operativeMain?.promotionBranchId === item?.promotionBranchId
                        newPromotion.push({
                            promotionBranchId: item?.promotionBranchId,
                            promotionType: checkMain && item?.type === "EXTRA" ? "BUY" : item?.type,
                            promotionId: item?.promotionId,
                            isMain: checkMain ? '1' : '0'
                        })
                    }
                })
                return newPromotion
            })
        }
        handleVoucher()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [promotions])

    const renderPromotionOption = useCallback(() => {
        if (promotions?.length && product?.itemId) {
            const newOption = promotions.find((item: any) => item?.itemId === product?.itemId)?.promotions || []
            return newOption
        }
        return []
    }, [promotions, product?.itemId])

    const renderDetailListExtra = (data: any, index?: number) => {
        if (data?.length) {
            const newText = data.map((item: any, index: number) => {
                return `${item?.itemName || ''} ${item?.qty || 0} ${item?.itemUnitName || ''}`
            })
            return newText.join(', ')
        }

        if (promotionCurrent?.length && (index || index === 0) && promotionCurrent[index]) {
            const newText: string[] = []
            if (promotionCurrent[index]?.type === "EXTRA" && promotionProduct?.length) {
                const promotionItem = treatments?.summeryTreatments.find((item: any) => item?.promotion?.some((info: any) => info?.promotionType === 'EXTRA' && info?.promotionBranchId === promotionCurrent[index]?.promotionBranchId))?.promotion?.find((item: any) => item?.promotionBranchId === promotionCurrent[index]?.promotionBranchId)
                if (promotionItem?.groupNumber) {
                    promotionCurrent[index]?.extra.forEach((item: any) => {
                        if (item?.type === "EXTRA" && promotionItem?.groupNumber === item?.groupNumber) {
                            newText.push(item?.itemName)
                        }
                    })
                    return newText.join(', ')
                }
            }
        }
        return <></>
    }


    const deleteItem = (id: number) => {
        const updatedItemsBarcode = [...itemsBarcode];
        const updatedStickerBarcode = [...stickerBarcode]
        updatedItemsBarcode.splice(id, 1);
        updatedStickerBarcode.splice(id, 1);
        setProduct(initialProductState)
        onLoadPromotionTreatments(updatedItemsBarcode)
        setItemsBarcode(updatedItemsBarcode);
        setStickerBarcode(updatedStickerBarcode)
        if (updatedItemsBarcode.length) {
            seleteItemBarCode(updatedItemsBarcode[updatedItemsBarcode.length - 1], updatedItemsBarcode.length - 1)
        }
        setPromotionCurrent([]);
        setPropmotionBranchMain({});
        setPromotionDelId(0);
        setPromotionProduct([]);
        setPromotionProductCurrent([]);
        setPromotionExtraValue({});
        setPromotionExtraBuy([]);
        setPromotionExtraNew([]);
        setPromotionBuy([]);
        setPromotionExtra([]);
        setVoucherProduct({})
        setSearchVoucher("")
        setStickerProduct({});
        setErrorMessage(initialErrorMessageState);
        setItems(undefined);
        setMedicineInformationId(undefined);
        setProductInstructions([]);
        setProductUnits([]);
        setProductUses([]);
        setProductSymptom([]);
    }


    const onOpenPopVoucherSelectLot = (item: any) => {
        setDataPopVoucherSelectLot(item)
        setPopVoucherSelectLot(true)
    }

    const onClerPopVoucherSelectLot = () => {
        setDataPopVoucherSelectLot({})
        setPopVoucherSelectLot(false)
    }

    const handleVoucherSelect = (item?: any) => {
        // set flag เฉพาะกรณีเลือก voucher ใหม่ ไม่ใช่การลบ
        setVoucherLoadClear(true)
        setSearchVoucher(item?.voucherCode || '')
        if (item?.voucherListId) {
            setVoucherProduct({ ...dataPopVoucherSelectLot, ...item })
            onClerPopVoucherSelectLot()
        } else {
            setVoucherProduct({})
        }
    }

    const handleNewTreatment = () => {
        const hasItemInSummary = _.merge(treatments.summeryTreatments.filter((sum: any) => {
            if (!sum?.promotion?.length) {
                return !itemsBarcode.some((item: any) => item?.itemId === sum?.itemId);
            } else {
                return !itemsBarcode.some((item: any) =>
                    sum.itemId === item?.itemId &&
                    sum?.promotion.every((info: any) => info?.promotionType !== 'EXTRA')
                );
            }
        }), itemsBarcode.map((item: any) => {
            return { ...item, total: cal_sum(false, item) }
        }));
        return hasItemInSummary || []
    }

    const onLoadVoucher = async () => {
        if (searchVoucher && searchVoucher !== '' && voucherProduct?.voucherCode !== searchVoucher && props.group !== "MATERIAL") {
            const patientId = treatments?.summeryTreatments?.find((item: any) => item?.patientId)?.patientId || 0

            const newTreatment = handleNewTreatment()

            const condition: VoucherFindByCodeProps = {
                code: searchVoucher,
                itemType: props.group,
                itemId: product?.itemId || 0,
                qty: product?.qty,
                min: _.sumBy(newTreatment.map((item: any) => {
                    if (item?.approvalItems?.status === ApprovalStatus.PENDING) {
                        const newData = JSON.parse(item?.approvalItems?.body)
                        return { ...item, total: newData?.total }
                    } else {
                        return { ...item }
                    }
                }), 'total'),
                patientId: props?.patientId || patientId
            }

            await VoucherApi.findVoucherByCode(condition).then((res) => {
                handleVoucherSelect(res?.data[0])
            }).catch((err) => {
                const error = err?.response?.data
                if (error.statusCode === 404) {
                    if (error.message === "NOT_FOUND_VOUCHER_CODE") {
                        setErrorSearchVoucher(t(`PAYMENT.MESSAGE.ERROR.${error.message}`))
                    } else {
                        notiError(t(`VOUCHER.POP_PRODUCT.MESSAGE.ERROR.${error.message}`))
                    }
                } else {
                    notiError(t(`VOUCHER.POP_PRODUCT.MESSAGE.ERROR.ERROR`))
                }
            })
        }
    }

    useEffect(() => {
        const updatedItemsBarcode = [...itemsBarcode];
        if (
            itemsBarcode?.length && updatedItemsBarcode[selectedIndex] &&
            product?.itemId &&
            updatedItemsBarcode[selectedIndex]?.itemId === product?.itemId
        ) {
            const newData = updatedItemsBarcode.map((item: any, index: number) => {
                if (index === selectedIndex && product?.itemId === item?.itemId) {
                    return {
                        ...product,
                        promotionBranchMain: promotionBranchMain,
                        promotionDelId: promotionDelId,
                        promotionExtraBuy: promotionExtraBuy,
                        promotionExtraNew: promotionExtraNew,
                        promotionExtraValue: promotionExtraValue,
                        // ถ้า user แตะ promotion แล้ว (promotionLoadClear) ให้เชื่อ promotionProduct เสมอ — แม้เป็น []
                        // (กรณี cancel/clear) ไม่งั้นจะ fallback ไป product.promotion ตัวเก่า ทำให้ค่าไม่เคลียร์
                        promotion: ((promotionLoadClear || !_.isEmpty(promotionProduct)) ? promotionProduct : (product?.promotion || [])),
                        ...handlePromotionDiscount({ ...product, promotionBranchMain: promotionBranchMain }),
                        ...handleVoucherDiscount({ ...product,voucher: voucherProduct })
                    }

                } else if (promotionExtraValue?.promotionBranchId && promotionExtraBuy.some((info: any) => info?.itemType !== "OPERATIVE" && info?.itemId === item?.itemId && info?.qty === item?.qty && item?.promotion?.every((i: any) => i?.promotionBranchId !== promotionExtraValue?.promotionBranchId))) {
                    return {
                        ...item,
                        promotion: [...item?.promotion,
                        {
                            promotionBranchId: promotionExtraValue?.promotionBranchId,
                            promotionType: "BUY",
                            promotionId: promotionExtraValue?.promotionId,
                            isMain: '0',
                            groupNumber: promotionExtraBuy[0]?.groupNumber
                        }]
                    }
                }
                else {
                    return item
                }
            })

            const promotionAll = renderCheckCurrentUsePromtion(newData)
            const newItemBarcode = newData?.map((item: any) => {
                if (item?.promotion?.length) {
                    return { ...item, promotion: [...item?.promotion?.filter((info: any) => promotionAll.includes(info?.promotionBranchId))] }
                }
                else {
                    return item
                }
            })
            setItemsBarcode(newItemBarcode);
        }
    }, [promotionDelId, promotionExtraBuy, promotionExtraNew, promotionExtraValue, promotionProduct, promotionBranchMain, voucherProduct])

    const renderVoucher = () => {
        if (voucherProduct?.voucherId) {
            return (
                <Box width={"100%"}>
                    <Box display={'flex'} alignItems={'center'} flexWrap={'wrap'} marginBottom={'8px'}>
                        <Box width={'140px'}>
                            {t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_NAME')}
                        </Box>
                        <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                            <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                                {voucherProduct?.voucherName}
                                {voucherProduct?.detail &&
                                    (
                                        <span>
                                            <Tooltip title={voucherProduct?.detail} placement={'top-start'} sx={{ 'path': { fill: '#A8A8A8' }, }}>
                                                <InfoIcon />
                                            </Tooltip>
                                        </span>
                                    )
                                }
                            </Box>
                        </Box>

                    </Box>
                    <Box display={'flex'} alignItems={'center'} flexWrap={'wrap'}>
                        <Box width={'140px'}>
                            {t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_COST')}
                        </Box>
                        <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                            <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                                {voucherProduct?.voucherPrice}
                                {voucherProduct?.voucherPriceUnit === "PERCENT" ?
                                    <Box>
                                        {'%'}
                                    </Box>
                                    : <Box>
                                        {t('PROMOTION.FORM.BATH')}
                                    </Box>
                                }
                            </Box>
                        </Box>

                    </Box>
                </Box>
            )
        } else if (vouchers?.length) {
            return (
                <Box width={"100%"}>
                    {vouchers.map((item: any, index: number) => {
                        return (
                            <Box key={index} display={'flex'} alignItems={'center'} flexWrap={'wrap'}>
                                <Box width={'140px'}>
                                    {t('Gift Voucher')}
                                </Box>
                                <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                                    <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                                        {item?.voucherName}
                                        {item?.detail &&
                                            (
                                                <span>
                                                    <Tooltip title={item?.detail} placement={'top-start'} sx={{ 'path': { fill: '#A8A8A8' }, }}>
                                                        <InfoIcon />
                                                    </Tooltip>
                                                </span>
                                            )
                                        }
                                    </Box>
                                    <Box
                                        sx={{ textDecoration: 'underline', color: colors.themeSecondColor, cursor: 'pointer', width: 'fit-content' }}
                                        onClick={() => onOpenPopVoucherSelectLot(item)}
                                    >
                                        {t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_SELECT_INDEX', { index: item?.voucherDetails?.length || 0 })}
                                    </Box>
                                </Box>

                            </Box>
                        )
                    })}
                </Box>
            )
        }
    }

    const renderCheckCurrentUsePromtion = (data?: any) => {
        const promotionAll: number[] = []
        handleSetTreatmentAll(data)?.forEach((item: any) => {
            if (item?.promotion?.length && item?.promotion?.some((info: any) => info.isMain === '1')) {
                const newItem = item?.promotion?.find((info: any) => info.isMain === '1')
                promotionAll.push(newItem?.promotionBranchId)
            }
        })
        return promotionAll
    }



    return (
        <ModalCustom
            size='xl'
            title={t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.${props.group}_TITLE`)}
            modalStyle={`popup-manage-product`}
            onClose={props.onCancel}
            handleClose
            component={
                (loading) ?
                    <Loading show type='fullLoading' /> :
                    <Box>{props.openScanBarcode && (
                        <Box>
                            <Typography sx={{ marginRight: { xs: '32px' }, fontWeight: 500 }}>
                                {t('TREATMENT_PRODUCT.CARD.ALL_ITEMS')}
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                                <Box sx={{ width: '100%', maxWidth: 379, paddingY: '16px' }}>
                                    <TextInput
                                        placeholder={t('TREATMENT_PRODUCT.CARD.SPECIFY_BARCODE')}
                                        value={scanBarcode}
                                        onChange={(event: any) => {
                                            setScanBarcode(event.target.value.replace(/\D/g, '').slice(0, 13));
                                        }}
                                        width={350}
                                        focus={true}
                                        inputProps={{
                                            value: scanBarcode,
                                            endAdornment: !scanBarcode ? (
                                                <FontAwesomeIcon icon={faSearch} style={{ color: colors.black60, fontSize: 15 }} />
                                            ) : (
                                                <FontAwesomeIcon icon={faTimes} onClick={() => setScanBarcode('')} style={{ color: colors.black60, fontSize: 17, cursor: 'pointer' }} />
                                            ),
                                            inputMode: 'numeric',
                                            pattern: '[0-9]*',
                                        }}
                                    />
                                </Box>
                                <Box>
                                    <MainButton
                                        onClick={() => {
                                            loadData()
                                            setScanBarcode('');
                                        }}
                                        title={t(`TREATMENT_PRODUCT.SEARCH_${props.group}`)}
                                        type={'primary'}
                                        variant={'contained'}
                                    />
                                </Box>
                            </Box>
                            <Box sx={{ border: '1px solid #E5E5E5', width: '100%', overflowX: 'auto', display: 'flex', flexDirection: 'row', paddingY: '8px', marginBottom: '16px', whiteSpace: 'nowrap' }}>
                                {(!_.isEmpty(itemsBarcode) && _.map(itemsBarcode, (med: any, index: number) => {
                                    return (
                                        <ProductBox
                                            key={`med-${index}`}
                                            className="px-1 px-xl-2 mb-2 mb-xl-3"
                                            onClick={() => seleteItemBarCode(med, index)}
                                            sx={{ flexShrink: 0 }}
                                        >
                                            <ProductBarCode className={selectedIndex === index ? 'active' : ''}>
                                                <Box sx={{ position: 'absolute', top: 6, right: 8, zIndex: 1 }}>
                                                    <IconButton
                                                        className={'btn-delete'}
                                                        disableFocusRipple
                                                        disableRipple
                                                        disableTouchRipple
                                                        aria-label="delete"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            deleteItem(index)
                                                        }
                                                        }
                                                        sx={{ backgroundColor: 'transparent !important', padding: 0, '&:disabled': { filter: 'grayscale(1)', opacity: 0.6 } }}
                                                    >
                                                        <img src={icons.btnTrash} alt="trash" style={{ width: 24 }} />
                                                    </IconButton>
                                                </Box>
                                                {selectedIndex === index && (
                                                    <Box sx={{
                                                        position: 'absolute', top: 0, left: 0, zIndex: 1,
                                                        background: colors.themeSecondColor,
                                                        borderRadius: '0px 0px 20px 0px',
                                                        width: '26px',
                                                        height: '26px',
                                                    }}>
                                                        <Box sx={{ marginTop: '-4px', marginLeft: '3px' }}><IconCheck fill={colors.white} /></Box>
                                                    </Box>
                                                )}
                                                <Box className="card-image">
                                                    <Box className="position-relative">
                                                        <img
                                                            src={renderImage(med.image)}
                                                            alt={med.itemName}
                                                            className={`${_.isEmpty(med.image) || !med.image?.filePath || !med.image?.fileName ? 'no-prod-image' : ''}`}
                                                            onError={onImgError}
                                                            style={{ ...(med.isOutOfStock && { opacity: 0.5 }) }}
                                                        />
                                                    </Box>
                                                </Box>
                                            </ProductBarCode>
                                        </ProductBox>
                                    );
                                })) || (
                                        <Typography
                                            className="w-100 text-center"
                                            sx={{ color: colors.disabledGray, paddingY: '30px', justifyContent: 'center' }}
                                        >
                                            {t(`TREATMENT_PRODUCT.TITLE.EMPTY_${props.group}`)}
                                        </Typography>
                                    )}
                            </Box>
                        </Box>
                    )}
                        <UseStyled.CustomPopupManageMedicine>
                            <Box className='d-flex flex-column flex-sm-row flex-wrap'>
                                {stickerProduct?.itemCode && (
                                    <Typography sx={{ marginRight: { xs: '32px' }, fontWeight: 500 }}>
                                        {t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.CODE')}: <span className='pl-1 pl-md-3'>{stickerProduct.itemCode}</span>
                                    </Typography>
                                )}
                                <Typography sx={{ fontWeight: 500 }}>
                                    {t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.${props.group}_NAME`)}: <span className='pl-1 pl-md-3'>{stickerProduct.itemName || stickerProduct.itemNameEn}</span>
                                </Typography>
                            </Box>
                            <Divider className="mx-0 my-4" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                            <Box className='d-sm-flex'>
                                <UseStyled.ImageMedicine className='w-100 mx-auto mb-4 mb-sm-0'>
                                    <Box className='image-wrap position-relative'>
                                        <img src={renderImage(stickerProduct.image || {})} alt={stickerProduct.itemName} onError={onImgError} className={`w-100 h-100`} />
                                    </Box>
                                    <Box className='d-flex justify-content-between inventory pt-1'>
                                        <Typography sx={{ flex: 'none' }}>{t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.QTY')}</Typography>
                                        <Box display="flex" justifyContent="space-between" alignItems="center">
                                            <Typography>{stickerProduct.stock || stickerProduct?.qty}</Typography>
                                            <Typography className='pl-1 text-ellipsis' title={stickerProduct.defaultProductUnitName || stickerProduct.unit}>{stickerProduct.defaultProductUnitName || stickerProduct.unit}</Typography>
                                        </Box>
                                    </Box>
                                </UseStyled.ImageMedicine>
                                <Box className='w-100' sx={{ paddingTop: { md: ((props.group === 'MEDICINE') && '8px') || 0 } }}>
                                    <Grid container spacing={2} className={'m-sm-0'} sx={{ width: { xs: '100%' } }}>
                                        {(props.group === 'MEDICINE') && (
                                            <>
                                                <Grid item md={4} lg={5} className={'w-100 pt-sm-0'}>
                                                    <Grid container spacing={2}>
                                                        <Grid item lg={11} className='' style={{ width: "calc(100% - 45px)" }}>
                                                            <AutocompleteSelect
                                                                labelId="productInstructionId"
                                                                inputLabel={t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PRODUCT_INSTRUCTION')}
                                                                noOptionsText={t('NOT_FOUND')}
                                                                options={productInstructions}
                                                                getOptionLabel={(option: any) => option.name || stickerProduct.productInstructionName}
                                                                renderOption={(props, option: any) => (
                                                                    <Box component="li" {...props} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                                                        {option.name}
                                                                        <IconButton className={`p-0`}
                                                                            onClick={() => handleDiscard("productInstructionId", option.id)}
                                                                            sx={{ backgroundColor: 'transparent', filter: 'grayscale(0)', opacity: 1 }}>
                                                                            <img src={icons.btnTrash} alt="discard" />
                                                                        </IconButton>
                                                                    </Box>

                                                                )}
                                                                onchange={(e, value: any) => {
                                                                    const newStickerProduct = {
                                                                        ...stickerProduct,
                                                                        productInstructionId: value?.id || 0,
                                                                        productInstructionName: _.get(_.find(productInstructions, { id: value?.id || 0 }), 'name')
                                                                    }
                                                                    setStickerProduct(newStickerProduct)
                                                                    setErrorMessage(initialErrorMessageState)
                                                                    handleChangeStickerProductDetail(newStickerProduct)
                                                                }}
                                                                inputProps={{
                                                                    onChange: (e: any) => {
                                                                        setDataLoading(true)
                                                                        setProductInstructions([])
                                                                        handleInputSearch('productInstructions', e.target.value)
                                                                    }
                                                                }}
                                                                onOpen={(e: any) => loadDefaultProductInstructions()}
                                                                value={stickerProduct?.productInstructionId ? _.find(productInstructions, { id: stickerProduct?.productInstructionId }) || '' : null}
                                                                loading={dataLoading}
                                                                disabledBorder
                                                                disableClearable={!stickerProduct.productInstructionId} />
                                                        </Grid>
                                                        <Grid item lg={1} className="pl-4" >
                                                            <IconAddBox className="" sx={{ backgroundColor: 'transparent !important', marginLeft: '-25px' }} onClick={onAddProductInstruction}>
                                                                <AddBoxIcon style={{ width: 30, height: 30 }} />
                                                            </IconAddBox>
                                                        </Grid>
                                                        <Grid item lg={4} className='w-100'>
                                                            {/* <TextInput
                                                                numberOnly
                                                                label={t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PRODUCT_DOSAGE')}
                                                                onChange={(e: any) => {
                                                                    const valueNumber = !e.target.value ? 0 : String(e.target.value).replace(/[^0-9.]/g, '')
                                                                    const newStickerProduct = { ...stickerProduct, dosage: Number(valueNumber) }
                                                                    setStickerProduct(newStickerProduct)
                                                                    setErrorMessage(initialErrorMessageState)
                                                                    handleChangeStickerProductDetail(newStickerProduct)
                                                                }}
                                                                fullWidth
                                                            /> */}
                                                            <InputTextField
                                                                type='number'
                                                                hideControl
                                                                label={t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PRODUCT_DOSAGE')}
                                                                value={!stickerProduct?.dosage ? '' : stickerProduct?.dosage}
                                                                onchange={(e: any) => {
                                                                    const valueNumber = !e.target.value ? 0 : String(e.target.value).replace(/[^0-9.]/g, '')
                                                                    const newStickerProduct = { ...stickerProduct, dosage: Number(valueNumber) }
                                                                    setStickerProduct(newStickerProduct)
                                                                    setErrorMessage(initialErrorMessageState)
                                                                    handleChangeStickerProductDetail(newStickerProduct)
                                                                }} />
                                                        </Grid>
                                                        <Grid item lg={7} className='' style={{ width: "calc(100% - 45px)" }}>
                                                            <AutocompleteSelect
                                                                inputLabel={t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PRODUCT_UNIT')}
                                                                labelId="productUnitId"
                                                                noOptionsText={t('NOT_FOUND')}
                                                                options={productUnits}
                                                                getOptionLabel={(option: any) => option.name || stickerProduct.productUnitName}
                                                                renderOption={(props, option: any) => (
                                                                    <Box component="li" {...props} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                                                        {option.name}
                                                                        <IconButton className={`p-0`}
                                                                            onClick={() => handleDiscard("productUnitId", option.id)}
                                                                            sx={{ backgroundColor: 'transparent', filter: 'grayscale(0)', opacity: 1 }}>
                                                                            <img src={icons.btnTrash} alt="discard" />
                                                                        </IconButton>
                                                                    </Box>
                                                                )}
                                                                onchange={(e, value: any) => {
                                                                    const newStickerProduct = {
                                                                        ...stickerProduct,
                                                                        productUnitId: value?.id || 0,
                                                                        productUnitName: _.get(_.find(productUnits, { id: value?.id || 0 }), 'name'),
                                                                        productUnitNameEn: _.get(_.find(productUnits, { id: value?.id || 0 }), 'nameEn'),
                                                                    }
                                                                    setStickerProduct(newStickerProduct)
                                                                    setErrorMessage(initialErrorMessageState)
                                                                    handleChangeStickerProductDetail(newStickerProduct)
                                                                }}
                                                                inputProps={{
                                                                    onChange: (e: any) => {
                                                                        setDataLoading(true)
                                                                        setProductUnits([])
                                                                        handleInputSearch('productUnits', e.target.value)
                                                                    }
                                                                }}
                                                                onOpen={(e: any) => loadDefaultProductUnits()}
                                                                value={stickerProduct.productUnitId ? _.find(productUnits, { id: stickerProduct.productUnitId }) || '' : null}
                                                                loading={dataLoading}
                                                                disabledBorder
                                                                disableClearable={!stickerProduct.productUnitId} />
                                                        </Grid>
                                                        <Grid item lg={1} className="pl-4">
                                                            <IconAddBox className="" sx={{ backgroundColor: 'transparent !important', marginLeft: '-25px' }} onClick={onAddProductUnit}>
                                                                <AddBoxIcon style={{ width: 30, height: 30 }} />
                                                            </IconAddBox>
                                                        </Grid>
                                                        <Grid item lg={11} className='' style={{ width: "calc(100% - 45px)" }}>
                                                            <AutocompleteSelect
                                                                inputLabel={t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PRODUCT_USE')}
                                                                labelId="productUseId"
                                                                noOptionsText={t('NOT_FOUND')}
                                                                options={productUses}
                                                                getOptionLabel={(option: any) => option.name || stickerProduct.productUseDetail}
                                                                renderOption={(props, option: any) => (
                                                                    <Box component="li" {...props} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                                                        {option.name}
                                                                        <IconButton className={`p-0`}
                                                                            onClick={() => handleDiscard("productUseId", option.id)}
                                                                            sx={{ backgroundColor: 'transparent', filter: 'grayscale(0)', opacity: 1 }}>
                                                                            <img src={icons.btnTrash} alt="discard" />
                                                                        </IconButton>
                                                                    </Box>
                                                                )}
                                                                onchange={(e, value: any) => {
                                                                    const newStickerProduct = {
                                                                        ...stickerProduct,
                                                                        productUseId: value?.id || 0,
                                                                        productUseDetail: _.get(_.find(productUses, { id: value?.id || 0 }), 'name')
                                                                    }
                                                                    setStickerProduct(newStickerProduct)
                                                                    setErrorMessage(initialErrorMessageState)
                                                                    handleChangeStickerProductDetail(newStickerProduct)
                                                                }}
                                                                inputProps={{
                                                                    onChange: (e: any) => {
                                                                        setDataLoading(true)
                                                                        setProductUses([])
                                                                        handleInputSearch('productUses', e.target.value)
                                                                    }
                                                                }}
                                                                onOpen={(e: any) => loadDefaultProductUses()}
                                                                value={stickerProduct.productUseId ? _.find(productUses, { id: stickerProduct.productUseId }) || '' : null}
                                                                loading={dataLoading}
                                                                disabledBorder
                                                                disableClearable={!stickerProduct.productUseId} />
                                                        </Grid>
                                                        <Grid item lg={1} className="pl-4">
                                                            <IconAddBox className="" sx={{ backgroundColor: 'transparent !important', marginLeft: '-25px' }} onClick={onAddProductUse}>
                                                                <AddBoxIcon style={{ width: 30, height: 30 }} />
                                                            </IconAddBox>
                                                        </Grid>
                                                        <Grid item lg={11} className='' style={{ width: "calc(100% - 45px)" }}>
                                                            <AutocompleteSelect
                                                                inputLabel={t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.SYMPTOM')}
                                                                labelId="productSymptomId"
                                                                noOptionsText={t('NOT_FOUND')}
                                                                options={productSymptom}
                                                                getOptionLabel={(option: any) => option.name || ''}
                                                                renderOption={(props, option: any) => (
                                                                    <Box component="li" {...props} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                                                        {option.name}
                                                                        <IconButton className={`p-0`}
                                                                            onClick={() => handleDiscard("productSymptomId", option.id)}
                                                                            sx={{ backgroundColor: 'transparent', filter: 'grayscale(0)', opacity: 1 }} >
                                                                            <img src={icons.btnTrash} alt="discard" />
                                                                        </IconButton>
                                                                    </Box>
                                                                )}
                                                                onchange={(e, value: any) => {
                                                                    const newStickerProduct = {
                                                                        ...stickerProduct,
                                                                        productSymptomId: value?.id || 0,
                                                                        productSymptomDetail: _.get(_.find(productSymptom, { id: value?.id || 0 }), 'name')
                                                                    }
                                                                    setStickerProduct(newStickerProduct)
                                                                    setErrorMessage(initialErrorMessageState)
                                                                    handleChangeStickerProductDetail(newStickerProduct)
                                                                }}
                                                                inputProps={{
                                                                    onChange: (e: any) => {
                                                                        setDataLoading(true)
                                                                        setProductSymptom([])
                                                                        handleInputSearch('productSymptom', e.target.value)
                                                                    }
                                                                }}
                                                                onOpen={(e: any) => loadDefaultProductSymtom()}
                                                                value={stickerProduct.productSymptomId ? _.find(productSymptom, { id: stickerProduct.productSymptomId }) || '' : null}
                                                                loading={dataLoading}
                                                                disabledBorder
                                                                disableClearable={!stickerProduct.productSymptomId} />

                                                        </Grid>
                                                        <Grid item lg={1} className="pl-4">
                                                            <IconAddBox className="" sx={{ backgroundColor: 'transparent !important', marginLeft: '-25px' }} onClick={onAddProductSymptom}>
                                                                <AddBoxIcon style={{ width: 30, height: 30 }} />
                                                            </IconAddBox>
                                                        </Grid>
                                                        <Grid item lg={11} className='' style={{ width: "calc(100% - 45px)" }}>
                                                            <AutocompleteSelect
                                                                inputLabel={t('ข้อควรระวัง')}
                                                                labelId="productWarningId"
                                                                noOptionsText={t('NOT_FOUND')}
                                                                options={productWarning}
                                                                getOptionLabel={(option: any) => option.name || ''}
                                                                renderOption={(props, option: any) => (
                                                                    <Box component="li" {...props} sx={{
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between',
                                                                        alignItems: 'flex-start',
                                                                        flexDirection: 'row',
                                                                        gap: 1,
                                                                    }}>
                                                                        <Box
                                                                            sx={{
                                                                                flex: 1,
                                                                                whiteSpace: 'normal',
                                                                                wordBreak: 'break-word',
                                                                                overflowWrap: 'break-word',
                                                                            }}
                                                                        >
                                                                            {option.name}
                                                                        </Box>
                                                                        <IconButton className={`p-0`}
                                                                            onClick={() => handleDiscard("productWarningId", option.id)}
                                                                            sx={{ backgroundColor: 'transparent', filter: 'grayscale(0)', opacity: 1 }} >
                                                                            <img src={icons.btnTrash} alt="discard" />
                                                                        </IconButton>
                                                                    </Box>
                                                                )}
                                                                onchange={(e, value: any) => {
                                                                    const newStickerProduct = {
                                                                        ...stickerProduct,
                                                                        productWarningId: value?.id || 0,
                                                                        productWarningDetail: _.get(_.find(productWarning, { id: value?.id || 0 }), 'name')
                                                                    }
                                                                    setStickerProduct(newStickerProduct)
                                                                    setErrorMessage(initialErrorMessageState)
                                                                    handleChangeStickerProductDetail(newStickerProduct)
                                                                }}
                                                                inputProps={{
                                                                    onChange: (e: any) => {
                                                                        setDataLoading(true)
                                                                        setProductWarning([])
                                                                        handleInputSearch('productWarning', e.target.value)
                                                                    }
                                                                }}
                                                                onOpen={(e: any) => loadDefaultProductWarning()}
                                                                value={stickerProduct.productWarningId ? _.find(productWarning, { id: stickerProduct.productWarningId }) || '' : null}
                                                                loading={dataLoading}
                                                                disabledBorder
                                                                disableClearable={!stickerProduct.productWarningId} />
                                                        </Grid>
                                                        <Grid item lg={1} className="pl-4">
                                                            <IconAddBox className="" sx={{ backgroundColor: 'transparent !important', marginLeft: '-25px' }} onClick={onAddProductWarning}>
                                                                <AddBoxIcon style={{ width: 30, height: 30 }} />
                                                            </IconAddBox>
                                                        </Grid>
                                                        {/* <Grid item className='w-100'>
                                                            <InputTextarea
                                                                height={'80px'}
                                                                label={t('ข้อควรระวัง')}
                                                                value={!stickerProduct.itemRecommend ? '' : stickerProduct.itemRecommend}
                                                                onchange={(e: any) => {
                                                                    if (e.target.value.length <= 40) {
                                                                        const newStickerProduct = { ...stickerProduct, itemRecommend: e.target.value }
                                                                        setStickerProduct(newStickerProduct)
                                                                        setErrorMessage(initialErrorMessageState)
                                                                        handleChangeStickerProductDetail(newStickerProduct)

                                                                        const contentLength = e.target.value.length
                                                                        if (contentLength > 40) setErrorMaxLength(true)
                                                                        else {
                                                                            setTextLength(contentLength)
                                                                            setErrorMaxLength(false)
                                                                        }
                                                                    }
                                                                }}
                                                                inputProps={{ maxLength: 40 }}
                                                            />
                                                            <Box sx={{ position: 'absolute', marginTop: '-20px', left: 530 }}>
                                                                <Typography sx={{ fontWeight: 400, fontSize: '10px', color: '#808080' }}>{`${textLength}/40`}</Typography>
                                                            </Box>
                                                        </Grid> */}
                                                    </Grid>
                                                </Grid>

                                                {/* label */}
                                                <Grid item md={8} lg={7} className={'w-100 pt-lg-0 d-flex flex-column'} sx={{ position: 'relative' }}>
                                                    <Typography sx={{ fontWeight: 500, position: 'absolute', top: '-24px', left: 0, zIndex: 10, backgroundColor: 'transparent' }}>{t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MEDICINE_LABEL_PREVIEW')}</Typography>
                                                    <Box className="h-100 w-100" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', zIndex: 1 }} >
                                                        <Box sx={{ width: '302.36220472px ', minHeight: '188.97637795px', height: 'auto', transform: `scale(1.513467746203101)`, backgroundColor: "#fff", marginTop: '16px' }}>
                                                            <Box sx={{ display: 'none' }}>
                                                                <Box ref={componentRef} className="h-100 w-100">
                                                                    <PdfMedSticker stickerData={[{ ...product, sticker: JSON.stringify(stickerProduct) }]} doctors={doctors} patientId={props?.patientId} isBarcode={props?.openScanBarcode} userId={doctor?.userId} />
                                                                </Box>
                                                            </Box>
                                                            <Box className="h-100 w-100" >
                                                                <PdfMedStickerView stickerData={[{ ...product, sticker: JSON.stringify(stickerProduct) }]} doctors={doctors} patientId={props?.patientId} isBarcode={props?.openScanBarcode} userId={doctor?.userId} />
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Grid>
                                            </>
                                        )}

                                        {/* summary */}
                                        <Grid item className={`${((props.group === 'MEDICINE') && 'mt-2') || 'pt-sm-0'} w-100`}>
                                            <Typography sx={{ fontWeight: 500 }}>{t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.${props.group}_DETAIL`)}</Typography>
                                            <Box className='d-sm-flex align-items-center justify-content-between mt-3'>
                                                <Typography className='pb-1 pb-sm-0' sx={{ flex: 'none' }}>{t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PREVIEW.DOCTOR')}</Typography>
                                                <Box className='w-100' sx={{ maxWidth: { xs: '245px' } }}>
                                                    <AutocompleteSelect
                                                        labelId="sl-dentist"
                                                        options={doctors}
                                                        getOptionLabel={(option) => option.fullname}
                                                        renderOption={(props, option) => {
                                                            return (
                                                                <Box
                                                                    {...props}
                                                                    key={option.userId}
                                                                    component="li"
                                                                    style={{
                                                                        pointerEvents: doctorHasOverDue(treatments, option.userId) ? 'none' : 'auto',
                                                                        color: doctorHasOverDue(treatments, option.userId) ? colors.disabledGray : colors.textPrimary
                                                                    }}>
                                                                    {option.fullname}
                                                                </Box>
                                                            )
                                                        }}
                                                        onchange={(e, value) => {
                                                            setDoctor(value)
                                                            handleChangeProductDetail('doctorId', value.userId)
                                                        }}
                                                        noOptionsText={t('NOT_FOUND')}
                                                        filterOptions={(option) => option.fullname}
                                                        value={doctor || null}
                                                        disableClearable
                                                        errMessage={errorMessage.EMPTY_DOCTOR || ``}
                                                    />
                                                </Box>
                                            </Box>
                                            <Box className='d-sm-flex justify-content-between mt-2'>
                                                <Typography className='pb-1 pb-sm-0' sx={{ flex: 'none', paddingTop: '10px' }}>
                                                    {t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.QTY_ORDER')}
                                                </Typography>
                                                <Box className='d-flex justify-content-between w-100' sx={{ maxWidth: { xs: '245px' } }}>
                                                    <Box className='w-100' sx={{ maxWidth: { xs: '150px' } }}>
                                                        <InputTextField
                                                            inputTextAlign={'right'}
                                                            value={product.qty}
                                                            onchange={(e: any) => handleChangeProductDetail('qty', Number(e.target.value), true)}
                                                            helperText={Number(product.qty) > (props.qty || Number(stickerProduct?.stock)) && t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.OVER_STOCK', { stock: stickerProduct.stock, unit: stickerProduct.defaultProductUnitName }) || errorMessage.EMPTY_QTY_ORDER || ''} />
                                                    </Box>
                                                    <Typography className='pl-1 text-right' sx={{ width: '80px', paddingTop: '10px' }}>{stickerProduct.defaultProductUnitName}</Typography>
                                                </Box>
                                            </Box>
                                            <Box className='d-sm-flex justify-content-between mt-2'>
                                                <Typography className='pb-1 pb-sm-0' sx={{ flex: 'none', paddingTop: '10px' }}>
                                                    {t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PRICE')}
                                                </Typography>
                                                <Box className='d-flex flex-column w-100' sx={{ maxWidth: { xs: '245px' } }}>
                                                    <Box className='d-flex justify-content-between w-100'>
                                                        <Box className='w-100' sx={{ maxWidth: { xs: '150px' } }}>
                                                            <InputTextField
                                                                disabled={props.hasChangeProductPrice === 'UNPERMISS'}
                                                                inputTextAlign={'right'}
                                                                value={product.price}
                                                                onchange={(e: any) => handleChangeProductDetail('price', e.target.value)}
                                                                helperText={errorMessage.EMPTY_PRICE || errorMessage.PRICE_RANGE || ''} />
                                                        </Box>
                                                        <Typography className='pl-1 text-right' sx={{ width: '80px', paddingTop: '10px' }}>{t('CURRENCY_CHANGE.TH')}</Typography>
                                                    </Box>
                                                    {hasPriceRangeAddon && (product as any)?.isPriceRange === '1' && (product as any)?.maxSalePrice && (
                                                        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 0.5 }}>
                                                            <Typography sx={{ fontSize: '12px', color: colors.themeSecondColor }}>
                                                                {t('PRODUCT.FORM.PRICE_RANGE') || 'ราคาช่วง'}: {numberFormat((product as any).minSalePrice || 0)} - {numberFormat((product as any).maxSalePrice || 0)} {t('CURRENCY_CHANGE.TH')}
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Box>
                                            <Box className='d-sm-flex justify-content-between mt-2'>
                                                <Typography className='pb-1 pb-sm-0' sx={{ flex: 'none', paddingTop: '10px' }}>
                                                    {t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.DISCOUNT')}
                                                </Typography>
                                                <Box className='d-flex justify-content-between w-100' sx={{ maxWidth: { xs: '245px' } }}>
                                                    <Box className='w-100' sx={{ maxWidth: { xs: '150px' } }}>
                                                        <InputTextField
                                                            disabled={props.hasChangeProductDiscountAdditional === 'UNPERMISS'}
                                                            hideControl
                                                            inputTextAlign={'right'}
                                                            value={product.discount}
                                                            onchange={(e: any) => handleChangeProductDetail('discount', e.target.value)}
                                                            helperText={product.discount > (product.price * product.qty) && t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.OVER_DISCOUNT', { price: numberFormat(product.price * product.qty || 0) }) || ''} />
                                                    </Box>
                                                    <Box sx={{ width: "80px" }}>
                                                        <BasicSelect
                                                            disabled={props.hasChangeProductDiscountAdditional === 'UNPERMISS'}
                                                            labelId="lb-unit"
                                                            selectId="sl-unit"
                                                            label=""
                                                            value={product.discountUnit || ""}
                                                            options={unitMenuItems}
                                                            onchange={(e: any) => handleChangeProductDetail('discountUnit', e.target.value)}
                                                        />
                                                    </Box>
                                                </Box>
                                            </Box>
                                            <Box className='d-sm-flex align-items-center justify-content-between mt-2'>
                                                <Typography className='pb-1 pb-sm-0' sx={{ flex: 'none' }}>
                                                    {t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.ADDON')}
                                                </Typography>
                                                <Box className='d-flex align-items-center justify-content-between w-100' sx={{ maxWidth: { xs: '245px' } }}>
                                                    <Box className='w-100' sx={{ maxWidth: { xs: '150px' } }}>
                                                        <InputTextField
                                                            disabled={props.hasChangeProductDiscountAdditional === 'UNPERMISS'}
                                                            inputTextAlign={'right'}
                                                            value={product.additional}
                                                            onchange={(e: any) => handleChangeProductDetail('additional', e.target.value)} />
                                                    </Box>
                                                    <Box sx={{ width: "80px" }}>
                                                        <BasicSelect
                                                            disabled={props.hasChangeProductDiscountAdditional === 'UNPERMISS'}
                                                            labelId="lb-unit"
                                                            selectId="sl-unit"
                                                            label=""
                                                            value={product.additionalUnit || ""}
                                                            options={unitMenuItems}
                                                            onchange={(e: any) => handleChangeProductDetail('additionalUnit', e.target.value)}
                                                        />
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Grid>

                                        <Grid item className={'w-100'} display={(props?.page === 'RetrospectiveOrder' || props.group === "MATERIAL" || !getCrm()) ? 'none' : 'block'}>
                                            <Box className='d-sm-flex justify-content-between mt-2'>
                                                <Box width={'100%'} >
                                                    <Box display={'flex'} alignItems={'center'} gap={'16px'}>
                                                        <Typography className='pb-1 pb-sm-0' sx={{ flex: 'none', paddingTop: '10px', width: '100px' }}>
                                                            {t('PROMOTION.MODAL_MANAGE.PROMOTION')}
                                                        </Typography>
                                                        <Box sx={{ maxWidth: '400px', width: '100%', '.MuiOutlinedInput-root': { paddingRight: '9px !important' }, '.MuiAutocomplete-popupIndicator': { transform: 'rotate(0deg) !important' } }}>
                                                            <AutocompleteSelect
                                                                labelId={'promotion'}
                                                                inputLabel={t('PROMOTION.FORM.PROMOTION_NAME')}
                                                                options={renderPromotionOption()}
                                                                noOptionsText={t('NOT_FOUND')}
                                                                getOptionLabel={(option) => option?.promotionFullName || ''}
                                                                renderOption={(props, option) => {
                                                                    return (
                                                                        <Box {...props}
                                                                            aria-disabled={renderCheckCurrentUsePromtion().includes(option?.promotionBranchId)}
                                                                        >
                                                                            {option?.promotionFullName || ''}
                                                                        </Box>
                                                                    )
                                                                }}
                                                                popupIcon={<FontAwesomeIcon icon={faSearch} style={{ fontSize: 15 }} />}
                                                                onchange={(e, value) => {
                                                                    // กดกากบาทหรือเลือกค่าว่าง => เคลียร์ promotion ทั้งหมด
                                                                    if (!value) {
                                                                        clearPromotionAll()
                                                                        return
                                                                    }
                                                                    // เลือก promotion "ตัวเดิม" ที่ใช้อยู่ → toggle ออก (เคลียร์ทั้งหมด)
                                                                    if (value?.promotionBranchId && value?.promotionBranchId === promotionBranchMain?.promotionBranchId) {
                                                                        clearPromotionAll()
                                                                        return
                                                                    }
                                                                    // เลือกตัวใหม่ (หรือยังไม่มี promo) → สลับ/ใช้ทันที
                                                                    // handleChangePromotionProduct จะ filter main เดิม (isMain='1') ออกแล้วใส่ตัวใหม่ + ตั้ง promotionDelId เพื่อล้างของเก่า
                                                                    handleChangePromotionProduct(value);
                                                                }}
                                                                value={promotionBranchMain?.promotionBranchId ? promotionBranchMain : null}
                                                                disableClearable={false}
                                                            />
                                                        </Box>
                                                    </Box>
                                                    {(promotionBranchMain?.promotionBranchId) &&
                                                        <Box margin={'8px 0'}>
                                                            <Box padding={'0 24px'} display={'flex'} flexDirection={'column'} gap={'8px'}>
                                                                <Box display={'flex'} alignItems={'center'} width={'100%'}>
                                                                    <Box minWidth={'160px'}>
                                                                        {t('PROMOTION.FORM.PROMOTION_NAME')}
                                                                    </Box>
                                                                    <Box className={'text-ellipsis'} width={'100%'} >
                                                                        {promotionBranchMain?.promotionName}
                                                                        {promotionBranchMain?.detail &&
                                                                            (
                                                                                <span>
                                                                                    <Tooltip title={promotionBranchMain?.detail} placement={'top-start'} sx={{ 'path': { fill: '#A8A8A8' }, }}>
                                                                                        <InfoIcon />
                                                                                    </Tooltip>
                                                                                </span>
                                                                            )
                                                                        }
                                                                    </Box>
                                                                </Box>
                                                                <Box display={'flex'} alignItems={'center'} width={'100%'}>
                                                                    <Box minWidth={'160px'}>{t('PROMOTION.FORM.TYPE')}</Box>
                                                                    <Box className={'text-ellipsis'} width={'100%'} >
                                                                        {promotionBranchMain?.type === 'DISCOUNT' ? t('PROMOTION.PROMOTION_TYPE.DISCOUNT') : t('PROMOTION.PROMOTION_TYPE.EXTRA')}
                                                                    </Box>
                                                                </Box>
                                                                {promotionBranchMain?.type === 'DISCOUNT' ?
                                                                    <Box display={'flex'} alignItems={'center'} width={'100%'}>
                                                                        <Box minWidth={'160px'}> {t('PROMOTION.FORM.COST')}</Box>
                                                                        <Box className={'text-ellipsis'} width={'100%'} >
                                                                            {promotionBranchMain?.promotionPrice} {promotionBranchMain?.promotionPriceUnit === "PERCENT" ? "%" : t('PROMOTION.FORM.BATH')}
                                                                        </Box>
                                                                    </Box>
                                                                    :
                                                                    <Box display={'flex'} alignItems={'center'} width={'100%'}>
                                                                        <Box minWidth={'160px'}>{t('PROMOTION.MODAL_MANAGE.LIST_EXTRA')}</Box>
                                                                        <Box className={'text-ellipsis'} width={'100%'} title={renderDetailListExtra(promotionExtraNew)}>
                                                                            {renderDetailListExtra(promotionExtraNew)}
                                                                        </Box>
                                                                    </Box>
                                                                }
                                                            </Box>
                                                        </Box>
                                                    }
                                                    {promotionCurrent?.length && promotionCurrent.filter((item: any) => item?.promotionBranchId !== promotionBranchMain?.promotionBranchId)?.length ?
                                                        <Box margin={'8px 0'}>
                                                            <Box>
                                                                {t('PROMOTION.MODAL_MANAGE.PROMOTION_BIND')}
                                                            </Box>
                                                            <Box width={"100%"}>
                                                                {promotionCurrent.filter((item: any) => item?.promotionBranchId !== promotionBranchMain?.promotionBranchId).map((item: any, index: number) => {
                                                                    if (item?.promotionBranchId !== promotionBranchMain?.promotionBranchId) {
                                                                        return (
                                                                            <Box key={index} padding={'0 24px'} display={'flex'} flexDirection={'column'} gap={'8px'}>
                                                                                <Box display={'flex'} alignItems={'center'} width={'100%'}>
                                                                                    <Box minWidth={'160px'}>{t('PROMOTION.FORM.PROMOTION_NAME')}</Box>
                                                                                    <Box className={'text-ellipsis'} width={'100%'} >
                                                                                        {item?.promotionName}
                                                                                        {item?.detail && (<span><Tooltip title={item?.detail} placement={'top-start'} sx={{ 'path': { fill: '#A8A8A8' }, }}><InfoIcon /></Tooltip></span>)}
                                                                                    </Box>
                                                                                </Box>
                                                                                <Box display={'flex'} alignItems={'center'} width={'100%'}>
                                                                                    <Box minWidth={'160px'}>{t('PROMOTION.FORM.TYPE')}</Box>
                                                                                    <Box className={'text-ellipsis'} width={'100%'} >
                                                                                        {item?.type === 'DISCOUNT' ? t('PROMOTION.PROMOTION_TYPE.DISCOUNT') : t('PROMOTION.PROMOTION_TYPE.EXTRA')}
                                                                                    </Box>
                                                                                </Box>
                                                                                {item?.type === 'DISCOUNT' ?
                                                                                    <Box display={'flex'} alignItems={'center'} width={'100%'}>
                                                                                        <Box minWidth={'160px'}>{t('PROMOTION.FORM.COST')}</Box>
                                                                                        <Box className={'text-ellipsis'} width={'100%'} >{item?.promotionPrice} {item?.promotionPriceUnit === "PERCENT" ? "%" : t('PROMOTION.FORM.BATH')}</Box>
                                                                                    </Box> :
                                                                                    <Box display={'flex'} alignItems={'center'} width={'100%'}>
                                                                                        <Box minWidth={'160px'}>{t('PROMOTION.MODAL_MANAGE.LIST_EXTRA')}</Box>
                                                                                        <Box className={'text-ellipsis'} width={'100%'} title={renderDetailListExtra([], index)}>
                                                                                            {renderDetailListExtra([], index)}
                                                                                        </Box>
                                                                                    </Box>
                                                                                }
                                                                            </Box>
                                                                        )
                                                                    }
                                                                })}
                                                            </Box>
                                                        </Box>
                                                        : <></>}
                                                </Box>
                                                <Box className='d-flex justify-content-between w-100' sx={{ maxWidth: { xs: '245px' } }}>
                                                    <Box className='w-100' sx={{ maxWidth: { xs: '150px' } }}>
                                                        <InputTextField
                                                            disabled
                                                            inputTextAlign={'right'}
                                                            value={promotionBranchMain?.type === "DISCOUNT" && promotionBranchMain?.promotionPrice || ''}
                                                        />
                                                    </Box>
                                                    <Box sx={{ width: "80px" }}>
                                                        <BasicSelect
                                                            disabled
                                                            labelId="lb-unit"
                                                            selectId="sl-unit"
                                                            label=""
                                                            value={promotionBranchMain?.promotionBranchId ? promotionBranchMain?.promotionPriceUnit === "PERCENT" ? units[0] : units[1] : ''}
                                                            options={unitMenuItems}
                                                        />
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Grid>

                                        <Grid item className={'w-100'} display={(props?.page === 'RetrospectiveOrder' || props.group === "MATERIAL" || !getCrm()) ? 'none' : 'block'}>
                                            <Box className='d-sm-flex justify-content-between mt-2'>
                                                <Box width={'100%'} >
                                                    <Box display={'flex'} alignItems={'center'} gap={'16px'}>
                                                        <Typography className='pb-1 pb-sm-0' sx={{ flex: 'none', paddingTop: '10px', width: '100px' }}>
                                                            {t('Gift Voucher')}
                                                        </Typography>
                                                        <Box sx={{ maxWidth: '400px', width: '100%', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <Box sx={{ width: '100%', '.MuiOutlinedInput-root': { paddingRight: '9px !important' }, '.MuiFormControl-root': { position: 'relative' }, '.MuiFormHelperText-root': { position: 'absolute', bottom: '-20px' } }}>
                                                                <InputTextField
                                                                    label={t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_CODE')}
                                                                    onchange={(event) => {
                                                                        setErrorSearchVoucher("")
                                                                        setSearchVoucher(event.target.value)
                                                                    }}
                                                                    value={searchVoucher || ''}
                                                                    inputProps={{
                                                                        endAdornment: (
                                                                            <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                                                                                {voucherProduct?.voucherName &&
                                                                                    <Box sx={{ cursor: 'pointer' }} onClick={handleVoucherSelect} >
                                                                                        <IconClose />
                                                                                    </Box>
                                                                                }
                                                                                <FontAwesomeIcon icon={faSearch} style={{ fontSize: 15 }} />
                                                                            </Box>
                                                                        ),
                                                                    }}
                                                                    helperText={errorSearchVoucher}
                                                                />
                                                            </Box>
                                                            <Box sx={{ minWidth: '100px', button: { width: '100%' } }}>
                                                                <MainButton
                                                                    onClick={onLoadVoucher}
                                                                    title={t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_CHECKCODE')}
                                                                    type={'primary'}
                                                                    variant={'outlined'}
                                                                />
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                    <Box margin={'8px 0'} padding={'8px 24px 0'} >
                                                        {renderVoucher()}
                                                    </Box>
                                                </Box>
                                                <Box className='d-flex justify-content-between w-100' sx={{ maxWidth: { xs: '245px' } }}>
                                                    <Box className='w-100' sx={{ maxWidth: { xs: '150px' } }}>
                                                        <InputTextField
                                                            disabled
                                                            inputTextAlign={'right'}
                                                            value={voucherProduct?.voucherPrice || ''}
                                                            onchange={() => null}
                                                        />
                                                    </Box>
                                                    <Box sx={{ width: "80px" }}>
                                                        <BasicSelect
                                                            disabled
                                                            labelId="lb-unit"
                                                            selectId="sl-unit"
                                                            label=""
                                                            value={voucherProduct?.voucherPriceUnit || ''}
                                                            options={unitMenuItems}
                                                        />
                                                    </Box>
                                                </Box>

                                            </Box>
                                        </Grid>

                                        <Grid item className={'w-100'}>
                                            <UseStyled.SummaryCost className='d-flex justify-content-end align-items-center px-3'>
                                                <Typography>{t('TREATMENT_SUMMARY.TITLE.SUM_TOTAL')}</Typography>
                                                <Typography className='pl-4 text-right' sx={{ minWidth: { sm: '200px' } }}>
                                                    {numberFormat(cal_sum(false, itemsBarcode[selectedIndex] || {}))} {t('CURRENCY_CHANGE.TH')}
                                                </Typography>
                                            </UseStyled.SummaryCost>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>
                            <UseStyled.GroupButton className='d-sm-flex align-items-center justify-content-between mt-2'>
                                <Box display="flex" gap="16px">
                                    {props.group === 'MEDICINE' && <MainButton type='primary' variant='outlined' title={t('TREATMENT_SUMMARY.BUTTON.REMEMBER')} onClick={onRemember} />}
                                    {(props.group === 'MEDICINE') && (
                                        <>
                                            <FunctionPrint
                                                content={() => componentRef.current}
                                                docTitle={t('TX_INFORMATION.TITLE')}
                                                removeIfram
                                                trigger={() => <ButtonCustom
                                                    disabled={(!product.qty || product.price.toString() === '' || (product.qty > (stickerProduct?.stock || 0)) || product.discount > (product.price * product.qty)) || (props.group === 'MEDICINE' && !_.find(doctors, { userId: product.doctorId }))}
                                                    textButton={t('BUTTON.PRINT')}
                                                    variant={'outlined'}
                                                    className='mt-3 mt-sm-0'
                                                    style={{ margin: 0 }} />}
                                                style={'@page { size: 302.36220472px 188.97637795px;  margin: 0cm;  } @media print { body { -webkit-print-color-adjust: exact; } '}
                                            />
                                        </>
                                    )}
                                </Box>
                                <Box display="flex" gap="16px">
                                    <MainButton type='secondary' variant='outlined' style={{ width: '120px' }} title={t('BUTTON.CANCEL')} onClick={props.onCancel} />
                                    <MainButton type='primary' variant='contained' style={{ width: '120px' }} title={t('BUTTON.SAVE')} onClick={onSubmitPopup} disabled={disabledSave} />
                                </Box>
                            </UseStyled.GroupButton>
                            {isShowAddProductChoice && (
                                <PopupManageProductAddForm
                                    type={typeAdd}
                                    items={items}
                                    isShow={isShowAddProductChoice}
                                    onSubmit={(data, type) => handleSubmit(data, type)}
                                    onCancel={() => setIsShowAddProductChoice(false)}
                                    maxLength={maxLength}
                                />
                            )}
                            {popPromotionExtra &&
                                <ModalSelectPromotionExtra
                                    promotionExtraValue={promotionExtraValue}
                                    onClose={onClerPopPromotionExtra}
                                    promotionExtra={promotionExtra}
                                    onChangePromotionExtra={onChangePromotionExtra}
                                    promotionBuy={promotionBuy}
                                />
                            }
                            {
                                popVoucherSelectLot &&
                                <ModalVoucherSelectLot
                                    onClose={onClerPopVoucherSelectLot}
                                    data={dataPopVoucherSelectLot}
                                    handleVoucherSelect={handleVoucherSelect}
                                />
                            }
                        </ UseStyled.CustomPopupManageMedicine>
                    </Box>
            }
        />
    )
}
